// tslint:disable
/**
 * enterprise.adapter.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.3.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from "url";
import { Configuration } from "./configuration";
import globalAxios, { AxiosPromise, AxiosInstance } from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @interface FieldError
 */
export interface FieldError {
  /**
   *
   * @type {string}
   * @memberof FieldError
   */
  resource?: string;
  /**
   *
   * @type {string}
   * @memberof FieldError
   */
  field?: string;
  /**
   *
   * @type {string}
   * @memberof FieldError
   */
  message?: string;
}
/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   *
   * @type {any}
   * @memberof InlineObject
   */
  gatewayFile?: any;
}
/**
 *
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
  /**
   *
   * @type {any}
   * @memberof InlineObject1
   */
  sensorFile?: any;
}
/**
 *
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
  /**
   *
   * @type {any}
   * @memberof InlineObject2
   */
  tabletFile?: any;
}
/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }   Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...   Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := ptypes.MarshalAny(foo)      ...      foo := &pb.Foo{}      if err := ptypes.UnmarshalAny(any, foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use \'type.googleapis.com/full.type.name\' as the type URL and the unpack methods only use the fully qualified type name after the last \'/\' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".   JSON ==== The JSON representation of an `Any` value uses the regular representation of the deserialized, embedded message, with an additional field `@type` which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": ,       \"lastName\":     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field `value` which holds the custom JSON in addition to the `@type` field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
  /**
   * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL\'s path must represent the fully qualified name of the type (as in `path/google.protobuf.Duration`). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme `http`, `https`, or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, `https` is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com.  Schemes other than `http`, `https` (or the empty scheme) might be used with implementation specific semantics.
   * @type {string}
   * @memberof ProtobufAny
   */
  typeUrl?: string;
  /**
   * Must be a valid serialized protocol buffer of the above specified type.
   * @type {string}
   * @memberof ProtobufAny
   */
  value?: string;
}
/**
 *
 * @export
 * @interface RuntimeError
 */
export interface RuntimeError {
  /**
   *
   * @type {string}
   * @memberof RuntimeError
   */
  error?: string;
  /**
   *
   * @type {number}
   * @memberof RuntimeError
   */
  code?: number;
  /**
   *
   * @type {string}
   * @memberof RuntimeError
   */
  message?: string;
  /**
   *
   * @type {Array<ProtobufAny>}
   * @memberof RuntimeError
   */
  details?: Array<ProtobufAny>;
  /**
   *
   * @type {Array<FieldError>}
   * @memberof RuntimeError
   */
  errors?: Array<FieldError>;
}
/**
 * AdminSession represents a system administrator.
 * @export
 * @interface V1AdminSession
 */
export interface V1AdminSession {
  /**
   *
   * @type {string}
   * @memberof V1AdminSession
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof V1AdminSession
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof V1AdminSession
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof V1AdminSession
   */
  mail?: string;
  /**
   *
   * @type {V1SessionToken}
   * @memberof V1AdminSession
   */
  tokens?: V1SessionToken;
}
/**
 * Alert represents a alert.
 * @export
 * @interface V1Alert
 */
export interface V1Alert {
  /**
   *
   * @type {string}
   * @memberof V1Alert
   */
  companyId?: string;
  /**
   *
   * @type {V1AlertType}
   * @memberof V1Alert
   */
  alertType?: V1AlertType;
  /**
   *
   * @type {V1AlertStatus}
   * @memberof V1Alert
   */
  status?: V1AlertStatus;
  /**
   *
   * @type {string}
   * @memberof V1Alert
   */
  floor?: string;
  /**
   *
   * @type {V1ToiletType}
   * @memberof V1Alert
   */
  kind?: string;
  /**
   *
   * @type {string}
   * @memberof V1Alert
   */
  areaName?: string;
  /**
   *
   * @type {string}
   * @memberof V1Alert
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1Alert
   */
  time?: string;
}
/**
 *
 * @export
 * @interface V1AlertDestination
 */
export interface V1AlertDestination {
  /**
   *
   * @type {string}
   * @memberof V1AlertDestination
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1AlertDestination
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof V1AlertDestination
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1AlertDestination
   */
  mailAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1AlertDestination
   */
  longStayAlertEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1AlertDestination
   */
  failureAlertEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1AlertDestination
   */
  lowBatteryAlertEnabled?: boolean;
}
/**
 * AlertStatus represents that status of alert.
 * @export
 * @enum {string}
 */
export enum V1AlertStatus {
  UNKNOWNALERTSTATUS = "UNKNOWN_ALERT_STATUS",
  ALERT = "ALERT",
  RESOLVED = "RESOLVED",
}

/**
 * AlertType represents that alert is long stay, low battery, failure.
 * @export
 * @enum {string}
 */
export enum V1AlertType {
  UNKNOWNALERTTYPE = "UNKNOWN_ALERT_TYPE",
  LONGSTAYALERT = "LONG_STAY_ALERT",
  LOWBATTERYALERT = "LOW_BATTERY_ALERT",
  FAILUREALERT = "FAILURE_ALERT",
}

/**
 *
 * @export
 * @interface V1AppService
 */
export interface V1AppService {
  /**
   *
   * @type {string}
   * @memberof V1AppService
   */
  name?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof V1AppService
   */
  options?: Array<string>;
}
/**
 *
 * @export
 * @interface V1AuthenticateAdminSessionResponse
 */
export interface V1AuthenticateAdminSessionResponse {
  /**
   *
   * @type {V1AdminSession}
   * @memberof V1AuthenticateAdminSessionResponse
   */
  adminUser?: V1AdminSession;
}
/**
 *
 * @export
 * @interface V1AuthenticateTenantSessionResponse
 */
export interface V1AuthenticateTenantSessionResponse {
  /**
   *
   * @type {V1TenantSession}
   * @memberof V1AuthenticateTenantSessionResponse
   */
  tenantUser?: V1TenantSession;
}
/**
 * Box represents a private room in toilet.
 * @export
 * @interface V1Box
 */
export interface V1Box {
  /**
   *
   * @type {string}
   * @memberof V1Box
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Box
   */
  toiletId?: string;
  /**
   *
   * @type {string}
   * @memberof V1Box
   */
  name?: string;
  /**
   *
   * @type {V1BoxStyle}
   * @memberof V1Box
   */
  boxStyle?: V1BoxStyle;
  /**
   *
   * @type {Array<string>}
   * @memberof V1Box
   */
  options?: Array<string>;
  /**
   *
   * @type {V1DoorType}
   * @memberof V1Box
   */
  doorType?: V1DoorType;
  /**
   *
   * @type {string}
   * @memberof V1Box
   */
  /**
   * @type {string, string}
   * @memberof V1Box
   */
  vacancyStatus?: { text: string; color: string };
  /**
   * @type {Array<object>}
   * @memberof V1Box
   */
  sensorList?: Array<Object>;
  sensorMac?: string;
  /**
   *
   * @type {V1BoxStatus}
   * @memberof V1Box
   */
  status?: V1BoxStatus;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum V1BoxStatus {
  UNKNOWNBOXSTATUS = "UNKNOWN_BOX_STATUS",
  RUNNING = "RUNNING",
  INMAINTENANCE = "IN_MAINTENANCE",
  INPREPARING = "IN_PREPARING",
}

/**
 *
 * @export
 * @enum {string}
 */
export enum V1BoxStyle {
  UNKNOWNBOXSTYLE = "UNKNOWN_BOX_STYLE",
  JAPANESE = "JAPANESE",
  WESTERN = "WESTERN",
}

/**
 * BoxUsedAnalyticsRecord represents a analyized records of used in box resource.
 * @export
 * @interface V1BoxUsedAnalyticsRecord
 */
export interface V1BoxUsedAnalyticsRecord {
  /**
   *
   * @type {string}
   * @memberof V1BoxUsedAnalyticsRecord
   */
  boxId?: string;
  /**
   *
   * @type {Array<V1UsedAnalyticsRecord>}
   * @memberof V1BoxUsedAnalyticsRecord
   */
  records?: Array<V1UsedAnalyticsRecord>;
}
/**
 *
 * @export
 * @interface V1BulkGatewaysCommitRequest
 */
export interface V1BulkGatewaysCommitRequest {
  /**
   *
   * @type {string}
   * @memberof V1BulkGatewaysCommitRequest
   */
  transactionId?: string;
}
/**
 *
 * @export
 * @interface V1BulkGatewaysCommitResponse
 */
export interface V1BulkGatewaysCommitResponse {
  /**
   *
   * @type {string}
   * @memberof V1BulkGatewaysCommitResponse
   */
  transactionId?: string;
}
/**
 *
 * @export
 * @interface V1BulkGatewaysTransactionResponse
 */
export interface V1BulkGatewaysTransactionResponse {
  /**
   *
   * @type {string}
   * @memberof V1BulkGatewaysTransactionResponse
   */
  transactionId?: string;
  /**
   *
   * @type {Array<V1BulkGatewaysTransactionRow>}
   * @memberof V1BulkGatewaysTransactionResponse
   */
  data?: Array<V1BulkGatewaysTransactionRow>;
}
/**
 *
 * @export
 * @interface V1BulkGatewaysTransactionRow
 */
export interface V1BulkGatewaysTransactionRow {
  /**
   *
   * @type {string}
   * @memberof V1BulkGatewaysTransactionRow
   */
  mac?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1BulkGatewaysTransactionRow
   */
  result?: boolean;
  /**
   *
   * @type {string}
   * @memberof V1BulkGatewaysTransactionRow
   */
  status?: string;
}
/**
 *
 * @export
 * @interface V1BulkSensorsCommitRequest
 */
export interface V1BulkSensorsCommitRequest {
  /**
   *
   * @type {string}
   * @memberof V1BulkSensorsCommitRequest
   */
  transactionId?: string;
}
/**
 *
 * @export
 * @interface V1BulkSensorsCommitResponse
 */
export interface V1BulkSensorsCommitResponse {
  /**
   *
   * @type {string}
   * @memberof V1BulkSensorsCommitResponse
   */
  transactionId?: string;
}
/**
 *
 * @export
 * @interface V1BulkSensorsTransactionResponse
 */
export interface V1BulkSensorsTransactionResponse {
  /**
   *
   * @type {string}
   * @memberof V1BulkSensorsTransactionResponse
   */
  transactionId?: string;
  /**
   *
   * @type {Array<V1BulkSensorsTransactionRow>}
   * @memberof V1BulkSensorsTransactionResponse
   */
  data?: Array<V1BulkSensorsTransactionRow>;
}
/**
 *
 * @export
 * @interface V1BulkSensorsTransactionRow
 */
export interface V1BulkSensorsTransactionRow {
  /**
   *
   * @type {string}
   * @memberof V1BulkSensorsTransactionRow
   */
  mac?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1BulkSensorsTransactionRow
   */
  result?: boolean;
  /**
   *
   * @type {string}
   * @memberof V1BulkSensorsTransactionRow
   */
  status?: string;
}
/**
 *
 * @export
 * @interface V1BulkTabletsCommitRequest
 */
export interface V1BulkTabletsCommitRequest {
  /**
   *
   * @type {string}
   * @memberof V1BulkTabletsCommitRequest
   */
  transactionId?: string;
}
/**
 *
 * @export
 * @interface V1BulkTabletsCommitResponse
 */
export interface V1BulkTabletsCommitResponse {
  /**
   *
   * @type {string}
   * @memberof V1BulkTabletsCommitResponse
   */
  transactionId?: string;
}
/**
 *
 * @export
 * @interface V1BulkTabletsTransactionResponse
 */
export interface V1BulkTabletsTransactionResponse {
  /**
   *
   * @type {string}
   * @memberof V1BulkTabletsTransactionResponse
   */
  transactionId?: string;
  /**
   *
   * @type {Array<V1BulkTabletsTransactionRow>}
   * @memberof V1BulkTabletsTransactionResponse
   */
  data?: Array<V1BulkTabletsTransactionRow>;
}
/**
 *
 * @export
 * @interface V1BulkTabletsTransactionRow
 */
export interface V1BulkTabletsTransactionRow {
  /**
   *
   * @type {string}
   * @memberof V1BulkTabletsTransactionRow
   */
  mac?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1BulkTabletsTransactionRow
   */
  result?: boolean;
  /**
   *
   * @type {string}
   * @memberof V1BulkTabletsTransactionRow
   */
  status?: string;
}
/**
 * Company represents a company resource.
 * @export
 * @interface V1Company
 */
export interface V1Company {
  /**
   *
   * @type {string}
   * @memberof V1Company
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Company
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1Company
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof V1Company
   */
  zipCode?: string;
  /**
   *
   * @type {string}
   * @memberof V1Company
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof V1Company
   */
  facilityName?: string;
  /**
   *
   * @type {V1CompanyDetails}
   * @memberof V1Company
   */
  details?: V1CompanyDetails;
}
/**
 *
 * @export
 * @interface V1CompanyDetails
 */
export interface V1CompanyDetails {
  /**
   *
   * @type {Array<V1AppService>}
   * @memberof V1CompanyDetails
   */
  services?: Array<V1AppService>;
  /**
   *
   * @type {boolean}
   * @memberof V1CompanyDetails
   */
  archived?: boolean;
}
/**
 * CountAnalyticsRecord represents a analyized records of counts resource.
 * @export
 * @interface V1CountAnalyticsRecord
 */
export interface V1CountAnalyticsRecord {
  /**
   *
   * @type {Array<string>}
   * @memberof V1CountAnalyticsRecord
   */
  labels?: Array<string>;
  /**
   *
   * @type {Array<V1CountRecord>}
   * @memberof V1CountAnalyticsRecord
   */
  datasets?: Array<V1CountRecord>;
}
/**
 * CountRecord represents a record of count resource.
 * @export
 * @interface V1CountRecord
 */
export interface V1CountRecord {
  /**
   *
   * @type {string}
   * @memberof V1CountRecord
   */
  label?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof V1CountRecord
   */
  value?: Array<number>;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum V1DoorType {
  UNKNOWNDOORTYPE = "UNKNOWN_DOOR_TYPE",
  NORMALLYOPENED = "NORMALLY_OPENED",
  NORMALLYCLOSED = "NORMALLY_CLOSED",
}

/**
 *
 * @export
 * @interface V1ExportBoxUsedAnalyticsResponse
 */
export interface V1ExportBoxUsedAnalyticsResponse {
  /**
   *
   * @type {string}
   * @memberof V1ExportBoxUsedAnalyticsResponse
   */
  raw?: string;
}
/**
 * FailureAlertSetting represents a alert setting for failure.
 * @export
 * @interface V1FailureAlertSetting
 */
export interface V1FailureAlertSetting {
  /**
   *
   * @type {string}
   * @memberof V1FailureAlertSetting
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof V1FailureAlertSetting
   */
  maxFailingDurationSeconds?: string;
}
/**
 * Gateway represents a gateway resource.
 * @export
 * @interface V1Gateway
 */
export interface V1Gateway {
  /**
   *
   * @type {string}
   * @memberof V1Gateway
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Gateway
   */
  mac?: string;
  /**
   *
   * @type {string}
   * @memberof V1Gateway
   */
  companyId?: string;
  /**
   *
   * @type {V1GatewayDetails}
   * @memberof V1Gateway
   */
  details?: V1GatewayDetails;
}
/**
 * GatewayDetais is a gateway related information.
 * @export
 * @interface V1GatewayDetails
 */
export interface V1GatewayDetails {
  /**
   *
   * @type {V1GatewayStatus}
   * @memberof V1GatewayDetails
   */
  status?: V1GatewayStatus;
  /**
   *
   * @type {string}
   * @memberof V1GatewayDetails
   */
  statusUpdatedTime?: string;
}
/**
 * GatewayStatus represents a gateway status.   - UNINITIALIZED: 未初期化  - RUNNING: 起動中  - SUSPENDED: 停止中
 * @export
 * @enum {string}
 */
export enum V1GatewayStatus {
  UNKNOWNGATEWAYSTATUS = "UNKNOWN_GATEWAY_STATUS",
  UNINITIALIZED = "UNINITIALIZED",
  RUNNING = "RUNNING",
  SUSPENDED = "SUSPENDED",
}

/**
 *
 * @export
 * @interface V1GetAuthParametersResponse
 */
export interface V1GetAuthParametersResponse {
  /**
   *
   * @type {boolean}
   * @memberof V1GetAuthParametersResponse
   */
  passcodeAuth?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1GetAuthParametersResponse
   */
  userAuth?: boolean;
}
/**
 *
 * @export
 * @interface V1GetHourlyUsagePercentageByAreaResponse
 */
export interface V1GetHourlyUsagePercentageByAreaResponse {
  /**
   *
   * @type {V1PercentagesByTime}
   * @memberof V1GetHourlyUsagePercentageByAreaResponse
   */
  stats?: V1PercentagesByTime;
}
/**
 *
 * @export
 * @interface V1GetHourlyUsageTimeByAreaResponse
 */
export interface V1GetHourlyUsageTimeByAreaResponse {
  /**
   *
   * @type {V1NumbersByTime}
   * @memberof V1GetHourlyUsageTimeByAreaResponse
   */
  stats?: V1NumbersByTime;
}
/**
 *
 * @export
 * @interface V1GetTenantResponse
 */
export interface V1GetTenantResponse {
  /**
   *
   * @type {V1Tenant}
   * @memberof V1GetTenantResponse
   */
  tenant?: V1Tenant;
}
/**
 *
 * @export
 * @interface V1GetTenantWebsiteStatusResponse
 */
export interface V1GetTenantWebsiteStatusResponse {
  /**
   *
   * @type {{ [key: string]: V1VacantStatus; }}
   * @memberof V1GetTenantWebsiteStatusResponse
   */
  statuses?: { [key: string]: V1VacantStatus };
}
/**
 *
 * @export
 * @interface V1Group
 */
export interface V1Group {
  /**
   *
   * @type {string}
   * @memberof V1Group
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1Group
   */
  groupType?: string;
  /**
   *
   * @type {string}
   * @memberof V1Group
   */
  groupCode?: string;
  /**
   *
   * @type {Array<V1Place>}
   * @memberof V1Group
   */
  places?: Array<V1Place>;
}
/**
 *
 * @export
 * @interface V1ListAlertDestinationsResponse
 */
export interface V1ListAlertDestinationsResponse {
  /**
   *
   * @type {Array<V1AlertDestination>}
   * @memberof V1ListAlertDestinationsResponse
   */
  alertDestinations?: Array<V1AlertDestination>;
  /**
   *
   * @type {number}
   * @memberof V1ListAlertDestinationsResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListAlertDestinationsResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListAlertsResponse
 */
export interface V1ListAlertsResponse {
  /**
   *
   * @type {Array<V1Alert>}
   * @memberof V1ListAlertsResponse
   */
  alerts?: Array<V1Alert>;
  /**
   *
   * @type {number}
   * @memberof V1ListAlertsResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListAlertsResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListBoxUsedAnalyticsResponse
 */
export interface V1ListBoxUsedAnalyticsResponse {
  /**
   *
   * @type {Array<V1BoxUsedAnalyticsRecord>}
   * @memberof V1ListBoxUsedAnalyticsResponse
   */
  records?: Array<V1BoxUsedAnalyticsRecord>;
}
/**
 *
 * @export
 * @interface V1ListBoxesResponse
 */
export interface V1ListBoxesResponse {
  /**
   *
   * @type {Array<V1Box>}
   * @memberof V1ListBoxesResponse
   */
  boxes?: Array<V1Box>;
  /**
   *
   * @type {number}
   * @memberof V1ListBoxesResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListBoxesResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListCompaniesResponse
 */
export interface V1ListCompaniesResponse {
  /**
   *
   * @type {Array<V1Company>}
   * @memberof V1ListCompaniesResponse
   */
  companies?: Array<V1Company>;
  /**
   *
   * @type {number}
   * @memberof V1ListCompaniesResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListCompaniesResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListDAUAnalyticsResponse
 */
export interface V1ListDAUAnalyticsResponse {
  /**
   *
   * @type {V1CountAnalyticsRecord}
   * @memberof V1ListDAUAnalyticsResponse
   */
  records?: V1CountAnalyticsRecord;
}
/**
 *
 * @export
 * @interface V1ListGatewaysResponse
 */
export interface V1ListGatewaysResponse {
  /**
   *
   * @type {Array<V1Gateway>}
   * @memberof V1ListGatewaysResponse
   */
  gateways?: Array<V1Gateway>;
  /**
   *
   * @type {number}
   * @memberof V1ListGatewaysResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListGatewaysResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListPageViewAnalyticsResponse
 */
export interface V1ListPageViewAnalyticsResponse {
  /**
   *
   * @type {V1CountAnalyticsRecord}
   * @memberof V1ListPageViewAnalyticsResponse
   */
  records?: V1CountAnalyticsRecord;
}
/**
 *
 * @export
 * @interface V1ListPublicPlacesResponse
 */
export interface V1ListPublicPlacesResponse {
  /**
   *
   * @type {Array<V1PublicPlace>}
   * @memberof V1ListPublicPlacesResponse
   */
  publicPlaces?: Array<V1PublicPlace>;
  /**
   *
   * @type {number}
   * @memberof V1ListPublicPlacesResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListPublicPlacesResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListSecondhandGatewaysResponse
 */
export interface V1ListSecondhandGatewaysResponse {
  /**
   *
   * @type {Array<V1SecondhandGateway>}
   * @memberof V1ListSecondhandGatewaysResponse
   */
  gateways?: Array<V1SecondhandGateway>;
  /**
   *
   * @type {number}
   * @memberof V1ListSecondhandGatewaysResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListSecondhandGatewaysResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListSecondhandSensorsResponse
 */
export interface V1ListSecondhandSensorsResponse {
  /**
   *
   * @type {Array<V1SecondhandSensor>}
   * @memberof V1ListSecondhandSensorsResponse
   */
  sensors?: Array<V1SecondhandSensor>;
  /**
   *
   * @type {number}
   * @memberof V1ListSecondhandSensorsResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListSecondhandSensorsResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListSecondhandTabletsResponse
 */
export interface V1ListSecondhandTabletsResponse {
  /**
   *
   * @type {Array<V1SecondhandTablet>}
   * @memberof V1ListSecondhandTabletsResponse
   */
  tablets?: Array<V1SecondhandTablet>;
  /**
   *
   * @type {number}
   * @memberof V1ListSecondhandTabletsResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListSecondhandTabletsResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListSensorsResponse
 */
export interface V1ListSensorsResponse {
  /**
   *
   * @type {Array<V1Sensor>}
   * @memberof V1ListSensorsResponse
   */
  sensors?: Array<V1Sensor>;
  /**
   *
   * @type {number}
   * @memberof V1ListSensorsResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListSensorsResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListStaytimeAnalyticsResponse
 */
export interface V1ListStaytimeAnalyticsResponse {
  /**
   *
   * @type {Array<V1StaytimeAnalyticsRecord>}
   * @memberof V1ListStaytimeAnalyticsResponse
   */
  records?: Array<V1StaytimeAnalyticsRecord>;
}
/**
 *
 * @export
 * @interface V1ListTabletsResponse
 */
export interface V1ListTabletsResponse {
  /**
   *
   * @type {Array<V1Tablet>}
   * @memberof V1ListTabletsResponse
   */
  tablets?: Array<V1Tablet>;
  /**
   *
   * @type {number}
   * @memberof V1ListTabletsResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListTabletsResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListTenantUsersResponse
 */
export interface V1ListTenantUsersResponse {
  /**
   *
   * @type {Array<V1TenantUser>}
   * @memberof V1ListTenantUsersResponse
   */
  tenantUsers?: Array<V1TenantUser>;
  /**
   *
   * @type {number}
   * @memberof V1ListTenantUsersResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListTenantUsersResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListToiletsResponse
 */
export interface V1ListToiletsResponse {
  /**
   *
   * @type {Array<V1Toilet>}
   * @memberof V1ListToiletsResponse
   */
  toilets?: Array<V1Toilet>;
  /**
   *
   * @type {number}
   * @memberof V1ListToiletsResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListToiletsResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListUsersResponse
 */
export interface V1ListUsersResponse {
  /**
   *
   * @type {Array<V1User>}
   * @memberof V1ListUsersResponse
   */
  users?: Array<V1User>;
  /**
   *
   * @type {number}
   * @memberof V1ListUsersResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListUsersResponse
   */
  totalPage?: number;
}
/**
 *
 * @export
 * @interface V1ListWebsitesResponse
 */
export interface V1ListWebsitesResponse {
  /**
   *
   * @type {Array<V1Website>}
   * @memberof V1ListWebsitesResponse
   */
  websites?: Array<V1Website>;
  /**
   *
   * @type {number}
   * @memberof V1ListWebsitesResponse
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof V1ListWebsitesResponse
   */
  totalPage?: number;
}
/**
 * LongStayAlertSetting represents a alert setting for long stay.
 * @export
 * @interface V1LongStayAlertSetting
 */
export interface V1LongStayAlertSetting {
  /**
   *
   * @type {string}
   * @memberof V1LongStayAlertSetting
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof V1LongStayAlertSetting
   */
  maxStayDurationSeconds?: string;
}
/**
 * LowBatteryAlertSetting represents a alert setting for low battery.
 * @export
 * @interface V1LowBatteryAlertSetting
 */
export interface V1LowBatteryAlertSetting {
  /**
   *
   * @type {string}
   * @memberof V1LowBatteryAlertSetting
   */
  companyId?: string;
  /**
   *
   * @type {number}
   * @memberof V1LowBatteryAlertSetting
   */
  threshold?: number;
}
/**
 *
 * @export
 * @interface V1NumberAndTime
 */
export interface V1NumberAndTime {
  /**
   *
   * @type {string}
   * @memberof V1NumberAndTime
   */
  time?: string;
  /**
   *
   * @type {number}
   * @memberof V1NumberAndTime
   */
  number?: number;
}
/**
 *
 * @export
 * @interface V1NumbersByTime
 */
export interface V1NumbersByTime {
  /**
   *
   * @type {Array<V1NumberAndTime>}
   * @memberof V1NumbersByTime
   */
  values?: Array<V1NumberAndTime>;
}
/**
 *
 * @export
 * @interface V1PercentageAndTime
 */
export interface V1PercentageAndTime {
  /**
   *
   * @type {string}
   * @memberof V1PercentageAndTime
   */
  time?: string;
  /**
   *
   * @type {number}
   * @memberof V1PercentageAndTime
   */
  percentage?: number;
}
/**
 *
 * @export
 * @interface V1PercentagesByTime
 */
export interface V1PercentagesByTime {
  /**
   *
   * @type {Array<V1PercentageAndTime>}
   * @memberof V1PercentagesByTime
   */
  values?: Array<V1PercentageAndTime>;
}
/**
 *
 * @export
 * @interface V1Place
 */
export interface V1Place {
  /**
   *
   * @type {string}
   * @memberof V1Place
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Place
   */
  floor?: string;
  /**
   *
   * @type {string}
   * @memberof V1Place
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1Place
   */
  stallsLabel?: string;
}
/**
 * PublicPlace represents a public place on website.
 * @export
 * @interface V1PublicPlace
 */
export interface V1PublicPlace {
  /**
   *
   * @type {string}
   * @memberof V1PublicPlace
   */
  websiteId?: string;
  /**
   *
   * @type {string}
   * @memberof V1PublicPlace
   */
  toiletId?: string;
  /**
   *
   * @type {number}
   * @memberof V1PublicPlace
   */
  sort?: number;
  /**
   *
   * @type {V1Toilet}
   * @memberof V1PublicPlace
   */
  toilet?: V1Toilet;
}
/**
 *
 * @export
 * @interface V1RefreshTokenResponse
 */
export interface V1RefreshTokenResponse {
  /**
   *
   * @type {V1SessionToken}
   * @memberof V1RefreshTokenResponse
   */
  tokens?: V1SessionToken;
}
/**
 * Secondhand Gateway represents a gateway resource.
 * @export
 * @interface V1SecondhandGateway
 */
export interface V1SecondhandGateway {
  /**
   *
   * @type {string}
   * @memberof V1SecondhandGateway
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandGateway
   */
  mac?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandGateway
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandGateway
   */
  endDate?: string;
}
/**
 * Secondhand Sensor represents a gateway resource.
 * @export
 * @interface V1SecondhandSensor
 */
export interface V1SecondhandSensor {
  /**
   *
   * @type {string}
   * @memberof V1SecondhandSensor
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandSensor
   */
  mac?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandSensor
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandSensor
   */
  endDate?: string;
}
/**
 * Secondhand Tablet represents a gateway resource.
 * @export
 * @interface V1SecondhandTablet
 */
export interface V1SecondhandTablet {
  /**
   *
   * @type {string}
   * @memberof V1SecondhandTablet
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandTablet
   */
  mac?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandTablet
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof V1SecondhandTablet
   */
  endDate?: string;
}
/**
 * Sensor represents a sensor resource.
 * @export
 * @interface V1Sensor
 */
export interface V1Sensor {
  /**
   *
   * @type {string}
   * @memberof V1Sensor
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Sensor
   */
  mac?: string;
  /**
   *
   * @type {string}
   * @memberof V1Sensor
   */
  sensorType?: string;
  /**
   *
   * @type {string}
   * @memberof V1Sensor
   */
  companyId?: string;
  /**
   *
   * @type {V1SensorDetails}
   * @memberof V1Sensor
   */
  details?: V1SensorDetails;
}
/**
 * SensorDetail represents a sensor with the battery, etc.
 * @export
 * @interface V1SensorDetails
 */
export interface V1SensorDetails {
  /**
   *
   * @type {number}
   * @memberof V1SensorDetails
   */
  battery?: number;
  /**
   *
   * @type {V1SensorStatus}
   * @memberof V1SensorDetails
   */
  status?: V1SensorStatus;
  /**
   *
   * @type {string}
   * @memberof V1SensorDetails
   */
  latestDataTime?: string;
}
/**
 * SensorStatus represents a Sensor status.   - UNINITIALIZED: 未初期化  - RUNNING: 起動中  - SUSPENDED: 停止中
 * @export
 * @enum {string}
 */
export enum V1SensorStatus {
  UNKNOWNSENSORSTATUS = "UNKNOWN_SENSOR_STATUS",
  UNINITIALIZED = "UNINITIALIZED",
  RUNNING = "RUNNING",
  SUSPENDED = "SUSPENDED",
}

/**
 * Token represents a authorized user tokens.
 * @export
 * @interface V1SessionToken
 */
export interface V1SessionToken {
  /**
   *
   * @type {string}
   * @memberof V1SessionToken
   */
  accessToken?: string;
  /**
   *
   * @type {string}
   * @memberof V1SessionToken
   */
  refreshToken?: string;
  /**
   *
   * @type {string}
   * @memberof V1SessionToken
   */
  idToken?: string;
}
/**
 * StaytimeAnalyticsRecord represents a analytics resource.
 * @export
 * @interface V1StaytimeAnalyticsRecord
 */
export interface V1StaytimeAnalyticsRecord {
  /**
   *
   * @type {string}
   * @memberof V1StaytimeAnalyticsRecord
   */
  toiletName?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof V1StaytimeAnalyticsRecord
   */
  data?: Array<number>;
}
/**
 * Tablet represents a tablet resource.
 * @export
 * @interface V1Tablet
 */
export interface V1Tablet {
  /**
   *
   * @type {string}
   * @memberof V1Tablet
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Tablet
   */
  mac?: string;
  /**
   *
   * @type {string}
   * @memberof V1Tablet
   */
  companyId?: string;
  /**
   *
   * @type {V1TabletDetails}
   * @memberof V1Tablet
   */
  details?: V1TabletDetails;
}
/**
 * TabletDetail represents a tablet with the battery, etc.
 * @export
 * @interface V1TabletDetails
 */
export interface V1TabletDetails {
  /**
   *
   * @type {V1TabletStatus}
   * @memberof V1TabletDetails
   */
  status?: V1TabletStatus;
  /**
   *
   * @type {string}
   * @memberof V1TabletDetails
   */
  latestDataTime?: string;
}
/**
 * TabletStatus represents a Tablet status.   - UNINITIALIZED: 未初期化  - RUNNING: 起動中  - SUSPENDED: 停止中
 * @export
 * @enum {string}
 */
export enum V1TabletStatus {
  UNKNOWNTABLETSTATUS = "UNKNOWN_TABLET_STATUS",
  UNINITIALIZED = "UNINITIALIZED",
  RUNNING = "RUNNING",
  SUSPENDED = "SUSPENDED",
}

/**
 *
 * @export
 * @interface V1Tenant
 */
export interface V1Tenant {
  /**
   *
   * @type {string}
   * @memberof V1Tenant
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Tenant
   */
  code?: string;
  /**
   *
   * @type {V1Website}
   * @memberof V1Tenant
   */
  website?: V1Website;
  /**
   *
   * @type {Array<V1ToiletGroup>}
   * @memberof V1Tenant
   */
  toiletGroups?: Array<V1ToiletGroup>;
}
/**
 * TenantSession represents a TenantSession.
 * @export
 * @interface V1TenantSession
 */
export interface V1TenantSession {
  /**
   *
   * @type {string}
   * @memberof V1TenantSession
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof V1TenantSession
   */
  tenantId?: string;
  /**
   *
   * @type {string}
   * @memberof V1TenantSession
   */
  role?: string;
  /**
   *
   * @type {V1SessionToken}
   * @memberof V1TenantSession
   */
  tokens?: V1SessionToken;
}
/**
 * TenantUser represents a tenant user.
 * @export
 * @interface V1TenantUser
 */
export interface V1TenantUser {
  /**
   *
   * @type {string}
   * @memberof V1TenantUser
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1TenantUser
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof V1TenantUser
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1TenantUser
   */
  mail?: string;
  /**
   *
   * @type {Array<V1Website>}
   * @memberof V1TenantUser
   */
  websites?: Array<V1Website>;
}
/**
 *
 * @export
 * @interface V1TenantWebsite
 */
export interface V1TenantWebsite {
  /**
   *
   * @type {string}
   * @memberof V1TenantWebsite
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1TenantWebsite
   */
  logoUrl?: string;
  /**
   *
   * @type {Array<V1Group>}
   * @memberof V1TenantWebsite
   */
  groups?: Array<V1Group>;
}
/**
 * Toilet represents a toilet.
 * @export
 * @interface V1Toilet
 */
export interface V1Toilet {
  /**
   *
   * @type {string}
   * @memberof V1Toilet
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Toilet
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof V1Toilet
   */
  name?: string;
  /**
   *
   * @type {V1ToiletType}
   * @memberof V1Toilet
   */
  toiletType?: V1ToiletType;
  /**
   *
   * @type {string}
   * @memberof V1Toilet
   */
  floor?: string;
  /**
   *
   * @type {number}
   * @memberof V1Toilet
   */
  boxesCount?: number;
  /**
   *
   * @type {string}
   * @memberof V1Toilet
   */
  gatewayMac?: string;
  /**
   * @type {string}
   * @memberof V1Toilet
   */
  gatewayId?: string;
  /**
   *
   * @type {V1ToiletStatus}
   * @memberof V1Toilet
   */
  status?: V1ToiletStatus;
}
/**
 *
 * @export
 * @interface V1ToiletGroup
 */
export interface V1ToiletGroup {
  /**
   *
   * @type {string}
   * @memberof V1ToiletGroup
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1ToiletGroup
   */
  name?: string;
  /**
   *
   * @type {Array<V1Toilet>}
   * @memberof V1ToiletGroup
   */
  toilets?: Array<V1Toilet>;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum V1ToiletStatus {
  UNKNOWNTOILETSTATUS = "UNKNOWN_TOILET_STATUS",
  RUNNING = "RUNNING",
  INMAINTENANCE = "IN_MAINTENANCE",
  INPREPARING = "IN_PREPARING",
}

/**
 *
 * @export
 * @enum {string}
 */
export enum V1ToiletType {
  UNKNOWNTOILETTYPE = "UNKNOWN_TOILET_TYPE",
  FORMAN = "FOR_MAN",
  FORWOMAN = "FOR_WOMAN",
  UNISEX = "UNISEX",
  MULTIPURPOSE = "MULTI_PURPOSE",
}

/**
 * UsedAnalyticsRecord represents a analyized records of used resource.
 * @export
 * @interface V1UsedAnalyticsRecord
 */
export interface V1UsedAnalyticsRecord {
  /**
   *
   * @type {string}
   * @memberof V1UsedAnalyticsRecord
   */
  name?: string;
  /**
   *
   * @type {Array<V1UsedRecord>}
   * @memberof V1UsedAnalyticsRecord
   */
  records?: Array<V1UsedRecord>;
}
/**
 * UsedAnalyticsRecord represents a record of staytime resource.
 * @export
 * @interface V1UsedRecord
 */
export interface V1UsedRecord {
  /**
   *
   * @type {Array<string>}
   * @memberof V1UsedRecord
   */
  value?: Array<string>;
}
/**
 * User represents a user.
 * @export
 * @interface V1User
 */
export interface V1User {
  /**
   *
   * @type {string}
   * @memberof V1User
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1User
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof V1User
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1User
   */
  mail?: string;
}
/**
 *
 * @export
 * @interface V1VacantStatus
 */
export interface V1VacantStatus {
  /**
   *
   * @type {number}
   * @memberof V1VacantStatus
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof V1VacantStatus
   */
  vacant?: number;
  /**
   *
   * @type {string}
   * @memberof V1VacantStatus
   */
  vacantLabel?: string;
  /**
   *
   * @type {string}
   * @memberOf V1VacantStatus
   */
  textColor?: string;
}
/**
 * Website represents a Website.
 * @export
 * @interface V1Website
 */
export interface V1Website {
  /**
   *
   * @type {string}
   * @memberof V1Website
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof V1Website
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof V1Website
   */
  displayName?: string;
  /**
   *
   * @type {string}
   * @memberof V1Website
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof V1Website
   */
  passcode?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1Website
   */
  useTenantIdPass?: boolean;
}

/**
 * AdminBulkUploadApi - axios parameter creator
 * @export
 */
export const AdminBulkUploadApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary ゲートウェイを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkGatewaysCommitRequest} [v1BulkGatewaysCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitGateways(
      xVACANCompanyId: string,
      v1BulkGatewaysCommitRequest?: V1BulkGatewaysCommitRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'xVACANCompanyId' is not null or undefined
      if (xVACANCompanyId === null || xVACANCompanyId === undefined) {
        throw new RequiredError(
          "xVACANCompanyId",
          "Required parameter xVACANCompanyId was null or undefined when calling bulkCommitGateways."
        );
      }
      const localVarPath = `/v1/admin/gateways/_bulk_commit`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xVACANCompanyId !== undefined && xVACANCompanyId !== null) {
        localVarHeaderParameter["X-VACAN-CompanyId"] = String(xVACANCompanyId);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };
      const needsSerialization =
        typeof v1BulkGatewaysCommitRequest !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            v1BulkGatewaysCommitRequest !== undefined
              ? v1BulkGatewaysCommitRequest
              : {}
          )
        : v1BulkGatewaysCommitRequest || "";

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary センサを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkSensorsCommitRequest} [v1BulkSensorsCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitSensors(
      xVACANCompanyId: string,
      v1BulkSensorsCommitRequest?: V1BulkSensorsCommitRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'xVACANCompanyId' is not null or undefined
      if (xVACANCompanyId === null || xVACANCompanyId === undefined) {
        throw new RequiredError(
          "xVACANCompanyId",
          "Required parameter xVACANCompanyId was null or undefined when calling bulkCommitSensors."
        );
      }
      const localVarPath = `/v1/admin/sensors/_bulk_commit`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xVACANCompanyId !== undefined && xVACANCompanyId !== null) {
        localVarHeaderParameter["X-VACAN-CompanyId"] = String(xVACANCompanyId);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };
      const needsSerialization =
        typeof v1BulkSensorsCommitRequest !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            v1BulkSensorsCommitRequest !== undefined
              ? v1BulkSensorsCommitRequest
              : {}
          )
        : v1BulkSensorsCommitRequest || "";

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary タブレットを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkTabletsCommitRequest} [v1BulkTabletsCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitTablets(
      xVACANCompanyId: string,
      v1BulkTabletsCommitRequest?: V1BulkTabletsCommitRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'xVACANCompanyId' is not null or undefined
      if (xVACANCompanyId === null || xVACANCompanyId === undefined) {
        throw new RequiredError(
          "xVACANCompanyId",
          "Required parameter xVACANCompanyId was null or undefined when calling bulkCommitTablets."
        );
      }
      const localVarPath = `/v1/admin/tablets/_bulk_commit`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xVACANCompanyId !== undefined && xVACANCompanyId !== null) {
        localVarHeaderParameter["X-VACAN-CompanyId"] = String(xVACANCompanyId);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };
      const needsSerialization =
        typeof v1BulkTabletsCommitRequest !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            v1BulkTabletsCommitRequest !== undefined
              ? v1BulkTabletsCommitRequest
              : {}
          )
        : v1BulkTabletsCommitRequest || "";

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary ゲートウェイを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [gatewayFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadGateways(
      xVACANCompanyId: string,
      gatewayFile?: any,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'xVACANCompanyId' is not null or undefined
      if (xVACANCompanyId === null || xVACANCompanyId === undefined) {
        throw new RequiredError(
          "xVACANCompanyId",
          "Required parameter xVACANCompanyId was null or undefined when calling bulkUploadGateways."
        );
      }
      const localVarPath = `/v1/admin/gateways/_bulk_upload`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (xVACANCompanyId !== undefined && xVACANCompanyId !== null) {
        localVarHeaderParameter["X-VACAN-CompanyId"] = String(xVACANCompanyId);
      }

      if (gatewayFile !== undefined) {
        localVarFormParams.append("gateway_file", gatewayFile as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary センサを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [sensorFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadSensors(
      xVACANCompanyId: string,
      sensorFile?: any,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'xVACANCompanyId' is not null or undefined
      if (xVACANCompanyId === null || xVACANCompanyId === undefined) {
        throw new RequiredError(
          "xVACANCompanyId",
          "Required parameter xVACANCompanyId was null or undefined when calling bulkUploadSensors."
        );
      }
      const localVarPath = `/v1/admin/sensors/_bulk_upload`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (xVACANCompanyId !== undefined && xVACANCompanyId !== null) {
        localVarHeaderParameter["X-VACAN-CompanyId"] = String(xVACANCompanyId);
      }

      if (sensorFile !== undefined) {
        localVarFormParams.append("sensor_file", sensorFile as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary タブレットを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [tabletFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadTablets(
      xVACANCompanyId: string,
      tabletFile?: any,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'xVACANCompanyId' is not null or undefined
      if (xVACANCompanyId === null || xVACANCompanyId === undefined) {
        throw new RequiredError(
          "xVACANCompanyId",
          "Required parameter xVACANCompanyId was null or undefined when calling bulkUploadTablets."
        );
      }
      const localVarPath = `/v1/admin/tablets/_bulk_upload`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (xVACANCompanyId !== undefined && xVACANCompanyId !== null) {
        localVarHeaderParameter["X-VACAN-CompanyId"] = String(xVACANCompanyId);
      }

      if (tabletFile !== undefined) {
        localVarFormParams.append("tablet_file", tabletFile as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AdminBulkUploadApi - functional programming interface
 * @export
 */
export const AdminBulkUploadApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary ゲートウェイを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkGatewaysCommitRequest} [v1BulkGatewaysCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitGateways(
      xVACANCompanyId: string,
      v1BulkGatewaysCommitRequest?: V1BulkGatewaysCommitRequest,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1BulkGatewaysCommitResponse> {
      const localVarAxiosArgs = AdminBulkUploadApiAxiosParamCreator(
        configuration
      ).bulkCommitGateways(
        xVACANCompanyId,
        v1BulkGatewaysCommitRequest,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary センサを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkSensorsCommitRequest} [v1BulkSensorsCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitSensors(
      xVACANCompanyId: string,
      v1BulkSensorsCommitRequest?: V1BulkSensorsCommitRequest,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1BulkSensorsCommitResponse> {
      const localVarAxiosArgs = AdminBulkUploadApiAxiosParamCreator(
        configuration
      ).bulkCommitSensors(xVACANCompanyId, v1BulkSensorsCommitRequest, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary タブレットを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkTabletsCommitRequest} [v1BulkTabletsCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitTablets(
      xVACANCompanyId: string,
      v1BulkTabletsCommitRequest?: V1BulkTabletsCommitRequest,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1BulkTabletsCommitResponse> {
      const localVarAxiosArgs = AdminBulkUploadApiAxiosParamCreator(
        configuration
      ).bulkCommitTablets(xVACANCompanyId, v1BulkTabletsCommitRequest, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary ゲートウェイを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [gatewayFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadGateways(
      xVACANCompanyId: string,
      gatewayFile?: any,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1BulkGatewaysTransactionResponse> {
      const localVarAxiosArgs = AdminBulkUploadApiAxiosParamCreator(
        configuration
      ).bulkUploadGateways(xVACANCompanyId, gatewayFile, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary センサを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [sensorFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadSensors(
      xVACANCompanyId: string,
      sensorFile?: any,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1BulkSensorsTransactionResponse> {
      const localVarAxiosArgs = AdminBulkUploadApiAxiosParamCreator(
        configuration
      ).bulkUploadSensors(xVACANCompanyId, sensorFile, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary タブレットを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [tabletFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadTablets(
      xVACANCompanyId: string,
      tabletFile?: any,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1BulkTabletsTransactionResponse> {
      const localVarAxiosArgs = AdminBulkUploadApiAxiosParamCreator(
        configuration
      ).bulkUploadTablets(xVACANCompanyId, tabletFile, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AdminBulkUploadApi - factory interface
 * @export
 */
export const AdminBulkUploadApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary ゲートウェイを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkGatewaysCommitRequest} [v1BulkGatewaysCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitGateways(
      xVACANCompanyId: string,
      v1BulkGatewaysCommitRequest?: V1BulkGatewaysCommitRequest,
      options?: any
    ): AxiosPromise<V1BulkGatewaysCommitResponse> {
      return AdminBulkUploadApiFp(configuration).bulkCommitGateways(
        xVACANCompanyId,
        v1BulkGatewaysCommitRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary センサを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkSensorsCommitRequest} [v1BulkSensorsCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitSensors(
      xVACANCompanyId: string,
      v1BulkSensorsCommitRequest?: V1BulkSensorsCommitRequest,
      options?: any
    ): AxiosPromise<V1BulkSensorsCommitResponse> {
      return AdminBulkUploadApiFp(configuration).bulkCommitSensors(
        xVACANCompanyId,
        v1BulkSensorsCommitRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary タブレットを登録するためにアップロードしたCSVをコミットする
     * @param {string} xVACANCompanyId
     * @param {V1BulkTabletsCommitRequest} [v1BulkTabletsCommitRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkCommitTablets(
      xVACANCompanyId: string,
      v1BulkTabletsCommitRequest?: V1BulkTabletsCommitRequest,
      options?: any
    ): AxiosPromise<V1BulkTabletsCommitResponse> {
      return AdminBulkUploadApiFp(configuration).bulkCommitTablets(
        xVACANCompanyId,
        v1BulkTabletsCommitRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary ゲートウェイを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [gatewayFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadGateways(
      xVACANCompanyId: string,
      gatewayFile?: any,
      options?: any
    ): AxiosPromise<V1BulkGatewaysTransactionResponse> {
      return AdminBulkUploadApiFp(configuration).bulkUploadGateways(
        xVACANCompanyId,
        gatewayFile,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary センサを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [sensorFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadSensors(
      xVACANCompanyId: string,
      sensorFile?: any,
      options?: any
    ): AxiosPromise<V1BulkSensorsTransactionResponse> {
      return AdminBulkUploadApiFp(configuration).bulkUploadSensors(
        xVACANCompanyId,
        sensorFile,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary タブレットを登録するためのCSVをアップロードする
     * @param {string} xVACANCompanyId
     * @param {any} [tabletFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUploadTablets(
      xVACANCompanyId: string,
      tabletFile?: any,
      options?: any
    ): AxiosPromise<V1BulkTabletsTransactionResponse> {
      return AdminBulkUploadApiFp(configuration).bulkUploadTablets(
        xVACANCompanyId,
        tabletFile,
        options
      )(axios, basePath);
    },
  };
};

/**
 * AdminBulkUploadApi - object-oriented interface
 * @export
 * @class AdminBulkUploadApi
 * @extends {BaseAPI}
 */
export class AdminBulkUploadApi extends BaseAPI {
  /**
   *
   * @summary ゲートウェイを登録するためにアップロードしたCSVをコミットする
   * @param {string} xVACANCompanyId
   * @param {V1BulkGatewaysCommitRequest} [v1BulkGatewaysCommitRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminBulkUploadApi
   */
  public bulkCommitGateways(
    xVACANCompanyId: string,
    v1BulkGatewaysCommitRequest?: V1BulkGatewaysCommitRequest,
    options?: any
  ) {
    return AdminBulkUploadApiFp(this.configuration).bulkCommitGateways(
      xVACANCompanyId,
      v1BulkGatewaysCommitRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary センサを登録するためにアップロードしたCSVをコミットする
   * @param {string} xVACANCompanyId
   * @param {V1BulkSensorsCommitRequest} [v1BulkSensorsCommitRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminBulkUploadApi
   */
  public bulkCommitSensors(
    xVACANCompanyId: string,
    v1BulkSensorsCommitRequest?: V1BulkSensorsCommitRequest,
    options?: any
  ) {
    return AdminBulkUploadApiFp(this.configuration).bulkCommitSensors(
      xVACANCompanyId,
      v1BulkSensorsCommitRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary タブレットを登録するためにアップロードしたCSVをコミットする
   * @param {string} xVACANCompanyId
   * @param {V1BulkTabletsCommitRequest} [v1BulkTabletsCommitRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminBulkUploadApi
   */
  public bulkCommitTablets(
    xVACANCompanyId: string,
    v1BulkTabletsCommitRequest?: V1BulkTabletsCommitRequest,
    options?: any
  ) {
    return AdminBulkUploadApiFp(this.configuration).bulkCommitTablets(
      xVACANCompanyId,
      v1BulkTabletsCommitRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary ゲートウェイを登録するためのCSVをアップロードする
   * @param {string} xVACANCompanyId
   * @param {any} [gatewayFile]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminBulkUploadApi
   */
  public bulkUploadGateways(
    xVACANCompanyId: string,
    gatewayFile?: any,
    options?: any
  ) {
    return AdminBulkUploadApiFp(this.configuration).bulkUploadGateways(
      xVACANCompanyId,
      gatewayFile,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary センサを登録するためのCSVをアップロードする
   * @param {string} xVACANCompanyId
   * @param {any} [sensorFile]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminBulkUploadApi
   */
  public bulkUploadSensors(
    xVACANCompanyId: string,
    sensorFile?: any,
    options?: any
  ) {
    return AdminBulkUploadApiFp(this.configuration).bulkUploadSensors(
      xVACANCompanyId,
      sensorFile,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary タブレットを登録するためのCSVをアップロードする
   * @param {string} xVACANCompanyId
   * @param {any} [tabletFile]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminBulkUploadApi
   */
  public bulkUploadTablets(
    xVACANCompanyId: string,
    tabletFile?: any,
    options?: any
  ) {
    return AdminBulkUploadApiFp(this.configuration).bulkUploadTablets(
      xVACANCompanyId,
      tabletFile,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * AlertDestinationsApi - axios parameter creator
 * @export
 */
export const AlertDestinationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary アラート通知先登録
     * @param {string} alertDestinationCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAlertDestination(
      alertDestinationCompanyId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'alertDestinationCompanyId' is not null or undefined
      if (
        alertDestinationCompanyId === null ||
        alertDestinationCompanyId === undefined
      ) {
        throw new RequiredError(
          "alertDestinationCompanyId",
          "Required parameter alertDestinationCompanyId was null or undefined when calling createAlertDestination."
        );
      }
      const localVarPath = `/v1/companies/{alertDestination.companyId}/alert_destinations`.replace(
        `{${"alertDestination.companyId"}}`,
        encodeURIComponent(String(alertDestinationCompanyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アラート通知先削除
     * @param {string} companyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAlertDestination(
      companyId: string,
      alertDestinationId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling deleteAlertDestination."
        );
      }
      // verify required parameter 'alertDestinationId' is not null or undefined
      if (alertDestinationId === null || alertDestinationId === undefined) {
        throw new RequiredError(
          "alertDestinationId",
          "Required parameter alertDestinationId was null or undefined when calling deleteAlertDestination."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/alert_destinations/{alertDestinationId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(
          `{${"alertDestinationId"}}`,
          encodeURIComponent(String(alertDestinationId))
        );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アラート通知先取得
     * @param {string} companyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAlertDestination(
      companyId: string,
      alertDestinationId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getAlertDestination."
        );
      }
      // verify required parameter 'alertDestinationId' is not null or undefined
      if (alertDestinationId === null || alertDestinationId === undefined) {
        throw new RequiredError(
          "alertDestinationId",
          "Required parameter alertDestinationId was null or undefined when calling getAlertDestination."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/alert_destinations/{alertDestinationId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(
          `{${"alertDestinationId"}}`,
          encodeURIComponent(String(alertDestinationId))
        );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アラート通知先検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAlertDestinations(
      companyId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listAlertDestinations."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/alert_destinations`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アラート通知先更新
     * @param {string} alertDestinationCompanyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAlertDestination(
      alertDestinationCompanyId: string,
      alertDestinationId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'alertDestinationCompanyId' is not null or undefined
      if (
        alertDestinationCompanyId === null ||
        alertDestinationCompanyId === undefined
      ) {
        throw new RequiredError(
          "alertDestinationCompanyId",
          "Required parameter alertDestinationCompanyId was null or undefined when calling updateAlertDestination."
        );
      }
      // verify required parameter 'alertDestinationId' is not null or undefined
      if (alertDestinationId === null || alertDestinationId === undefined) {
        throw new RequiredError(
          "alertDestinationId",
          "Required parameter alertDestinationId was null or undefined when calling updateAlertDestination."
        );
      }
      const localVarPath = `/v1/companies/{alertDestination.companyId}/alert_destinations/{alertDestination.id}`
        .replace(
          `{${"alertDestination.companyId"}}`,
          encodeURIComponent(String(alertDestinationCompanyId))
        )
        .replace(
          `{${"alertDestination.id"}}`,
          encodeURIComponent(String(alertDestinationId))
        );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AlertDestinationsApi - functional programming interface
 * @export
 */
export const AlertDestinationsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary アラート通知先登録
     * @param {string} alertDestinationCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAlertDestination(
      alertDestinationCompanyId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1AlertDestination> {
      const localVarAxiosArgs = AlertDestinationsApiAxiosParamCreator(
        configuration
      ).createAlertDestination(alertDestinationCompanyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary アラート通知先削除
     * @param {string} companyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAlertDestination(
      companyId: string,
      alertDestinationId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = AlertDestinationsApiAxiosParamCreator(
        configuration
      ).deleteAlertDestination(companyId, alertDestinationId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary アラート通知先取得
     * @param {string} companyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAlertDestination(
      companyId: string,
      alertDestinationId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1AlertDestination> {
      const localVarAxiosArgs = AlertDestinationsApiAxiosParamCreator(
        configuration
      ).getAlertDestination(companyId, alertDestinationId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary アラート通知先検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAlertDestinations(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListAlertDestinationsResponse> {
      const localVarAxiosArgs = AlertDestinationsApiAxiosParamCreator(
        configuration
      ).listAlertDestinations(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary アラート通知先更新
     * @param {string} alertDestinationCompanyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAlertDestination(
      alertDestinationCompanyId: string,
      alertDestinationId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1AlertDestination> {
      const localVarAxiosArgs = AlertDestinationsApiAxiosParamCreator(
        configuration
      ).updateAlertDestination(
        alertDestinationCompanyId,
        alertDestinationId,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AlertDestinationsApi - factory interface
 * @export
 */
export const AlertDestinationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary アラート通知先登録
     * @param {string} alertDestinationCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAlertDestination(
      alertDestinationCompanyId: string,
      options?: any
    ): AxiosPromise<V1AlertDestination> {
      return AlertDestinationsApiFp(configuration).createAlertDestination(
        alertDestinationCompanyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary アラート通知先削除
     * @param {string} companyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAlertDestination(
      companyId: string,
      alertDestinationId: string,
      options?: any
    ): AxiosPromise<object> {
      return AlertDestinationsApiFp(configuration).deleteAlertDestination(
        companyId,
        alertDestinationId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary アラート通知先取得
     * @param {string} companyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAlertDestination(
      companyId: string,
      alertDestinationId: string,
      options?: any
    ): AxiosPromise<V1AlertDestination> {
      return AlertDestinationsApiFp(configuration).getAlertDestination(
        companyId,
        alertDestinationId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary アラート通知先検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAlertDestinations(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListAlertDestinationsResponse> {
      return AlertDestinationsApiFp(configuration).listAlertDestinations(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary アラート通知先更新
     * @param {string} alertDestinationCompanyId
     * @param {string} alertDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAlertDestination(
      alertDestinationCompanyId: string,
      alertDestinationId: string,
      options?: any
    ): AxiosPromise<V1AlertDestination> {
      return AlertDestinationsApiFp(configuration).updateAlertDestination(
        alertDestinationCompanyId,
        alertDestinationId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * AlertDestinationsApi - object-oriented interface
 * @export
 * @class AlertDestinationsApi
 * @extends {BaseAPI}
 */
export class AlertDestinationsApi extends BaseAPI {
  /**
   *
   * @summary アラート通知先登録
   * @param {string} alertDestinationCompanyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertDestinationsApi
   */
  public createAlertDestination(
    alertDestinationCompanyId: string,
    options?: any
  ) {
    return AlertDestinationsApiFp(this.configuration).createAlertDestination(
      alertDestinationCompanyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary アラート通知先削除
   * @param {string} companyId
   * @param {string} alertDestinationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertDestinationsApi
   */
  public deleteAlertDestination(
    companyId: string,
    alertDestinationId: string,
    options?: any
  ) {
    return AlertDestinationsApiFp(this.configuration).deleteAlertDestination(
      companyId,
      alertDestinationId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary アラート通知先取得
   * @param {string} companyId
   * @param {string} alertDestinationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertDestinationsApi
   */
  public getAlertDestination(
    companyId: string,
    alertDestinationId: string,
    options?: any
  ) {
    return AlertDestinationsApiFp(this.configuration).getAlertDestination(
      companyId,
      alertDestinationId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary アラート通知先検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertDestinationsApi
   */
  public listAlertDestinations(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return AlertDestinationsApiFp(this.configuration).listAlertDestinations(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary アラート通知先更新
   * @param {string} alertDestinationCompanyId
   * @param {string} alertDestinationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertDestinationsApi
   */
  public updateAlertDestination(
    alertDestinationCompanyId: string,
    alertDestinationId: string,
    options?: any
  ) {
    return AlertDestinationsApiFp(this.configuration).updateAlertDestination(
      alertDestinationCompanyId,
      alertDestinationId,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * AlertSettingsApi - axios parameter creator
 * @export
 */
export const AlertSettingsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 機器故障アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFailureAlertSetting(companyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getFailureAlertSetting."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/alerts/settings/failure`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 滞在アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLongStayAlertSetting(companyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getLongStayAlertSetting."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/alerts/settings/long_stay`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 電池残量低下アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLowBatteryAlertSetting(
      companyId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getLowBatteryAlertSetting."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/alerts/settings/low_battery`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 機器故障アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFailureAlertSetting(
      alertSettingCompanyId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'alertSettingCompanyId' is not null or undefined
      if (
        alertSettingCompanyId === null ||
        alertSettingCompanyId === undefined
      ) {
        throw new RequiredError(
          "alertSettingCompanyId",
          "Required parameter alertSettingCompanyId was null or undefined when calling updateFailureAlertSetting."
        );
      }
      const localVarPath = `/v1/companies/{alertSetting.companyId}/alerts/settings/failure`.replace(
        `{${"alertSetting.companyId"}}`,
        encodeURIComponent(String(alertSettingCompanyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 滞在アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLongStayAlertSetting(
      alertSettingCompanyId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'alertSettingCompanyId' is not null or undefined
      if (
        alertSettingCompanyId === null ||
        alertSettingCompanyId === undefined
      ) {
        throw new RequiredError(
          "alertSettingCompanyId",
          "Required parameter alertSettingCompanyId was null or undefined when calling updateLongStayAlertSetting."
        );
      }
      const localVarPath = `/v1/companies/{alertSetting.companyId}/alerts/settings/long_stay`.replace(
        `{${"alertSetting.companyId"}}`,
        encodeURIComponent(String(alertSettingCompanyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 電池残量低下アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLowBatteryAlertSetting(
      alertSettingCompanyId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'alertSettingCompanyId' is not null or undefined
      if (
        alertSettingCompanyId === null ||
        alertSettingCompanyId === undefined
      ) {
        throw new RequiredError(
          "alertSettingCompanyId",
          "Required parameter alertSettingCompanyId was null or undefined when calling updateLowBatteryAlertSetting."
        );
      }
      const localVarPath = `/v1/companies/{alertSetting.companyId}/alerts/settings/low_battery`.replace(
        `{${"alertSetting.companyId"}}`,
        encodeURIComponent(String(alertSettingCompanyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AlertSettingsApi - functional programming interface
 * @export
 */
export const AlertSettingsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 機器故障アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFailureAlertSetting(
      companyId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1FailureAlertSetting> {
      const localVarAxiosArgs = AlertSettingsApiAxiosParamCreator(
        configuration
      ).getFailureAlertSetting(companyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 滞在アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLongStayAlertSetting(
      companyId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1LongStayAlertSetting> {
      const localVarAxiosArgs = AlertSettingsApiAxiosParamCreator(
        configuration
      ).getLongStayAlertSetting(companyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 電池残量低下アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLowBatteryAlertSetting(
      companyId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1LowBatteryAlertSetting> {
      const localVarAxiosArgs = AlertSettingsApiAxiosParamCreator(
        configuration
      ).getLowBatteryAlertSetting(companyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 機器故障アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFailureAlertSetting(
      alertSettingCompanyId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1FailureAlertSetting> {
      const localVarAxiosArgs = AlertSettingsApiAxiosParamCreator(
        configuration
      ).updateFailureAlertSetting(alertSettingCompanyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 滞在アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLongStayAlertSetting(
      alertSettingCompanyId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1LongStayAlertSetting> {
      const localVarAxiosArgs = AlertSettingsApiAxiosParamCreator(
        configuration
      ).updateLongStayAlertSetting(alertSettingCompanyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 電池残量低下アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLowBatteryAlertSetting(
      alertSettingCompanyId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1LowBatteryAlertSetting> {
      const localVarAxiosArgs = AlertSettingsApiAxiosParamCreator(
        configuration
      ).updateLowBatteryAlertSetting(alertSettingCompanyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AlertSettingsApi - factory interface
 * @export
 */
export const AlertSettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary 機器故障アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFailureAlertSetting(
      companyId: string,
      options?: any
    ): AxiosPromise<V1FailureAlertSetting> {
      return AlertSettingsApiFp(configuration).getFailureAlertSetting(
        companyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 滞在アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLongStayAlertSetting(
      companyId: string,
      options?: any
    ): AxiosPromise<V1LongStayAlertSetting> {
      return AlertSettingsApiFp(configuration).getLongStayAlertSetting(
        companyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 電池残量低下アラート設定取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLowBatteryAlertSetting(
      companyId: string,
      options?: any
    ): AxiosPromise<V1LowBatteryAlertSetting> {
      return AlertSettingsApiFp(configuration).getLowBatteryAlertSetting(
        companyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 機器故障アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFailureAlertSetting(
      alertSettingCompanyId: string,
      options?: any
    ): AxiosPromise<V1FailureAlertSetting> {
      return AlertSettingsApiFp(configuration).updateFailureAlertSetting(
        alertSettingCompanyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 滞在アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLongStayAlertSetting(
      alertSettingCompanyId: string,
      options?: any
    ): AxiosPromise<V1LongStayAlertSetting> {
      return AlertSettingsApiFp(configuration).updateLongStayAlertSetting(
        alertSettingCompanyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 電池残量低下アラート設定更新
     * @param {string} alertSettingCompanyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLowBatteryAlertSetting(
      alertSettingCompanyId: string,
      options?: any
    ): AxiosPromise<V1LowBatteryAlertSetting> {
      return AlertSettingsApiFp(configuration).updateLowBatteryAlertSetting(
        alertSettingCompanyId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * AlertSettingsApi - object-oriented interface
 * @export
 * @class AlertSettingsApi
 * @extends {BaseAPI}
 */
export class AlertSettingsApi extends BaseAPI {
  /**
   *
   * @summary 機器故障アラート設定取得
   * @param {string} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertSettingsApi
   */
  public getFailureAlertSetting(companyId: string, options?: any) {
    return AlertSettingsApiFp(this.configuration).getFailureAlertSetting(
      companyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 滞在アラート設定取得
   * @param {string} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertSettingsApi
   */
  public getLongStayAlertSetting(companyId: string, options?: any) {
    return AlertSettingsApiFp(this.configuration).getLongStayAlertSetting(
      companyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 電池残量低下アラート設定取得
   * @param {string} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertSettingsApi
   */
  public getLowBatteryAlertSetting(companyId: string, options?: any) {
    return AlertSettingsApiFp(this.configuration).getLowBatteryAlertSetting(
      companyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 機器故障アラート設定更新
   * @param {string} alertSettingCompanyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertSettingsApi
   */
  public updateFailureAlertSetting(
    alertSettingCompanyId: string,
    options?: any
  ) {
    return AlertSettingsApiFp(this.configuration).updateFailureAlertSetting(
      alertSettingCompanyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 滞在アラート設定更新
   * @param {string} alertSettingCompanyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertSettingsApi
   */
  public updateLongStayAlertSetting(
    alertSettingCompanyId: string,
    options?: any
  ) {
    return AlertSettingsApiFp(this.configuration).updateLongStayAlertSetting(
      alertSettingCompanyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 電池残量低下アラート設定更新
   * @param {string} alertSettingCompanyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertSettingsApi
   */
  public updateLowBatteryAlertSetting(
    alertSettingCompanyId: string,
    options?: any
  ) {
    return AlertSettingsApiFp(this.configuration).updateLowBatteryAlertSetting(
      alertSettingCompanyId,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * AlertsApi - axios parameter creator
 * @export
 */
export const AlertsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary アラート検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAlerts(
      companyId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listAlerts."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/alerts/logs`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AlertsApi - functional programming interface
 * @export
 */
export const AlertsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary アラート検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAlerts(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListAlertsResponse> {
      const localVarAxiosArgs = AlertsApiAxiosParamCreator(
        configuration
      ).listAlerts(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AlertsApi - factory interface
 * @export
 */
export const AlertsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary アラート検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAlerts(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListAlertsResponse> {
      return AlertsApiFp(configuration).listAlerts(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
  };
};

/**
 * AlertsApi - object-oriented interface
 * @export
 * @class AlertsApi
 * @extends {BaseAPI}
 */
export class AlertsApi extends BaseAPI {
  /**
   *
   * @summary アラート検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlertsApi
   */
  public listAlerts(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return AlertsApiFp(this.configuration).listAlerts(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 使用率の集計結果のCSVを返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportBoxUsedAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling exportBoxUsedAnalytics."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling exportBoxUsedAnalytics."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toliets/{toiletId}/used.csv`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startUnixtime !== undefined) {
        localVarQueryParameter["startUnixtime"] = startUnixtime;
      }

      if (endUnixtime !== undefined) {
        localVarQueryParameter["endUnixtime"] = endUnixtime;
      }

      if (unit !== undefined) {
        localVarQueryParameter["unit"] = unit;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 使用率の集計結果を返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {string} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listBoxUsedAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      format?: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listBoxUsedAnalytics."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling listBoxUsedAnalytics."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toliets/{toiletId}/used`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startUnixtime !== undefined) {
        localVarQueryParameter["startUnixtime"] = startUnixtime;
      }

      if (endUnixtime !== undefined) {
        localVarQueryParameter["endUnixtime"] = endUnixtime;
      }

      if (unit !== undefined) {
        localVarQueryParameter["unit"] = unit;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary DAUの週結果を返す
     * @param {string} companyId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDAUAnalytics(
      companyId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listDAUAnalytics."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/dau`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startUnixtime !== undefined) {
        localVarQueryParameter["startUnixtime"] = startUnixtime;
      }

      if (endUnixtime !== undefined) {
        localVarQueryParameter["endUnixtime"] = endUnixtime;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary PageViewの集計結果を返す
     * @param {string} companyId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPageViewAnalytics(
      companyId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listPageViewAnalytics."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/pv`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startUnixtime !== undefined) {
        localVarQueryParameter["startUnixtime"] = startUnixtime;
      }

      if (endUnixtime !== undefined) {
        localVarQueryParameter["endUnixtime"] = endUnixtime;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 滞在時間の集計結果を返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {string} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStaytimeAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      format?: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listStaytimeAnalytics."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling listStaytimeAnalytics."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toliets/{toiletId}/staytime`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startUnixtime !== undefined) {
        localVarQueryParameter["startUnixtime"] = startUnixtime;
      }

      if (endUnixtime !== undefined) {
        localVarQueryParameter["endUnixtime"] = endUnixtime;
      }

      if (unit !== undefined) {
        localVarQueryParameter["unit"] = unit;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 使用率の集計結果のCSVを返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportBoxUsedAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ExportBoxUsedAnalyticsResponse> {
      const localVarAxiosArgs = AnalyticsApiAxiosParamCreator(
        configuration
      ).exportBoxUsedAnalytics(
        companyId,
        toiletId,
        startUnixtime,
        endUnixtime,
        unit,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 使用率の集計結果を返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {string} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listBoxUsedAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      format?: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListBoxUsedAnalyticsResponse> {
      const localVarAxiosArgs = AnalyticsApiAxiosParamCreator(
        configuration
      ).listBoxUsedAnalytics(
        companyId,
        toiletId,
        startUnixtime,
        endUnixtime,
        unit,
        format,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary DAUの週結果を返す
     * @param {string} companyId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDAUAnalytics(
      companyId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListDAUAnalyticsResponse> {
      const localVarAxiosArgs = AnalyticsApiAxiosParamCreator(
        configuration
      ).listDAUAnalytics(companyId, startUnixtime, endUnixtime, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary PageViewの集計結果を返す
     * @param {string} companyId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPageViewAnalytics(
      companyId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListPageViewAnalyticsResponse> {
      const localVarAxiosArgs = AnalyticsApiAxiosParamCreator(
        configuration
      ).listPageViewAnalytics(companyId, startUnixtime, endUnixtime, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 滞在時間の集計結果を返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {string} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStaytimeAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      format?: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListStaytimeAnalyticsResponse> {
      const localVarAxiosArgs = AnalyticsApiAxiosParamCreator(
        configuration
      ).listStaytimeAnalytics(
        companyId,
        toiletId,
        startUnixtime,
        endUnixtime,
        unit,
        format,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary 使用率の集計結果のCSVを返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportBoxUsedAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      options?: any
    ): AxiosPromise<V1ExportBoxUsedAnalyticsResponse> {
      return AnalyticsApiFp(configuration).exportBoxUsedAnalytics(
        companyId,
        toiletId,
        startUnixtime,
        endUnixtime,
        unit,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 使用率の集計結果を返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {string} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listBoxUsedAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      format?: string,
      options?: any
    ): AxiosPromise<V1ListBoxUsedAnalyticsResponse> {
      return AnalyticsApiFp(configuration).listBoxUsedAnalytics(
        companyId,
        toiletId,
        startUnixtime,
        endUnixtime,
        unit,
        format,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary DAUの週結果を返す
     * @param {string} companyId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDAUAnalytics(
      companyId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      options?: any
    ): AxiosPromise<V1ListDAUAnalyticsResponse> {
      return AnalyticsApiFp(configuration).listDAUAnalytics(
        companyId,
        startUnixtime,
        endUnixtime,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary PageViewの集計結果を返す
     * @param {string} companyId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPageViewAnalytics(
      companyId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      options?: any
    ): AxiosPromise<V1ListPageViewAnalyticsResponse> {
      return AnalyticsApiFp(configuration).listPageViewAnalytics(
        companyId,
        startUnixtime,
        endUnixtime,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 滞在時間の集計結果を返す
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [startUnixtime]
     * @param {string} [endUnixtime]
     * @param {string} [unit]
     * @param {string} [format]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStaytimeAnalytics(
      companyId: string,
      toiletId: string,
      startUnixtime?: string,
      endUnixtime?: string,
      unit?: string,
      format?: string,
      options?: any
    ): AxiosPromise<V1ListStaytimeAnalyticsResponse> {
      return AnalyticsApiFp(configuration).listStaytimeAnalytics(
        companyId,
        toiletId,
        startUnixtime,
        endUnixtime,
        unit,
        format,
        options
      )(axios, basePath);
    },
  };
};

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
  /**
   *
   * @summary 使用率の集計結果のCSVを返す
   * @param {string} companyId
   * @param {string} toiletId
   * @param {string} [startUnixtime]
   * @param {string} [endUnixtime]
   * @param {string} [unit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsApi
   */
  public exportBoxUsedAnalytics(
    companyId: string,
    toiletId: string,
    startUnixtime?: string,
    endUnixtime?: string,
    unit?: string,
    options?: any
  ) {
    return AnalyticsApiFp(this.configuration).exportBoxUsedAnalytics(
      companyId,
      toiletId,
      startUnixtime,
      endUnixtime,
      unit,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 使用率の集計結果を返す
   * @param {string} companyId
   * @param {string} toiletId
   * @param {string} [startUnixtime]
   * @param {string} [endUnixtime]
   * @param {string} [unit]
   * @param {string} [format]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsApi
   */
  public listBoxUsedAnalytics(
    companyId: string,
    toiletId: string,
    startUnixtime?: string,
    endUnixtime?: string,
    unit?: string,
    format?: string,
    options?: any
  ) {
    return AnalyticsApiFp(this.configuration).listBoxUsedAnalytics(
      companyId,
      toiletId,
      startUnixtime,
      endUnixtime,
      unit,
      format,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary DAUの週結果を返す
   * @param {string} companyId
   * @param {string} [startUnixtime]
   * @param {string} [endUnixtime]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsApi
   */
  public listDAUAnalytics(
    companyId: string,
    startUnixtime?: string,
    endUnixtime?: string,
    options?: any
  ) {
    return AnalyticsApiFp(this.configuration).listDAUAnalytics(
      companyId,
      startUnixtime,
      endUnixtime,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary PageViewの集計結果を返す
   * @param {string} companyId
   * @param {string} [startUnixtime]
   * @param {string} [endUnixtime]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsApi
   */
  public listPageViewAnalytics(
    companyId: string,
    startUnixtime?: string,
    endUnixtime?: string,
    options?: any
  ) {
    return AnalyticsApiFp(this.configuration).listPageViewAnalytics(
      companyId,
      startUnixtime,
      endUnixtime,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 滞在時間の集計結果を返す
   * @param {string} companyId
   * @param {string} toiletId
   * @param {string} [startUnixtime]
   * @param {string} [endUnixtime]
   * @param {string} [unit]
   * @param {string} [format]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsApi
   */
  public listStaytimeAnalytics(
    companyId: string,
    toiletId: string,
    startUnixtime?: string,
    endUnixtime?: string,
    unit?: string,
    format?: string,
    options?: any
  ) {
    return AnalyticsApiFp(this.configuration).listStaytimeAnalytics(
      companyId,
      toiletId,
      startUnixtime,
      endUnixtime,
      unit,
      format,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * BoxesApi - axios parameter creator
 * @export
 */
export const BoxesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 個室登録
     * @param {string} companyId
     * @param {string} boxToiletId この個室が存在するトイレのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBox(
      companyId: string,
      boxToiletId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling createBox."
        );
      }
      // verify required parameter 'boxToiletId' is not null or undefined
      if (boxToiletId === null || boxToiletId === undefined) {
        throw new RequiredError(
          "boxToiletId",
          "Required parameter boxToiletId was null or undefined when calling createBox."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toilets/{box.toiletId}/boxes`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(
          `{${"box.toiletId"}}`,
          encodeURIComponent(String(boxToiletId))
        );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 個室削除
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBox(
      companyId: string,
      toiletId: string,
      boxId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling deleteBox."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling deleteBox."
        );
      }
      // verify required parameter 'boxId' is not null or undefined
      if (boxId === null || boxId === undefined) {
        throw new RequiredError(
          "boxId",
          "Required parameter boxId was null or undefined when calling deleteBox."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toilets/{toiletId}/boxes/{boxId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)))
        .replace(`{${"boxId"}}`, encodeURIComponent(String(boxId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 個室取得
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBox(
      companyId: string,
      toiletId: string,
      boxId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getBox."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling getBox."
        );
      }
      // verify required parameter 'boxId' is not null or undefined
      if (boxId === null || boxId === undefined) {
        throw new RequiredError(
          "boxId",
          "Required parameter boxId was null or undefined when calling getBox."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toilets/{toiletId}/boxes/{boxId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)))
        .replace(`{${"boxId"}}`, encodeURIComponent(String(boxId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 個室検索
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listBoxes(
      companyId: string,
      toiletId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listBoxes."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling listBoxes."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toilets/{toiletId}/boxes`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 個室更新
     * @param {string} companyId
     * @param {string} boxToiletId この個室が存在するトイレのID
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBox(
      companyId: string,
      boxToiletId: string,
      boxId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling updateBox."
        );
      }
      // verify required parameter 'boxToiletId' is not null or undefined
      if (boxToiletId === null || boxToiletId === undefined) {
        throw new RequiredError(
          "boxToiletId",
          "Required parameter boxToiletId was null or undefined when calling updateBox."
        );
      }
      // verify required parameter 'boxId' is not null or undefined
      if (boxId === null || boxId === undefined) {
        throw new RequiredError(
          "boxId",
          "Required parameter boxId was null or undefined when calling updateBox."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toilets/{box.toiletId}/boxes/{box.id}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"box.toiletId"}}`, encodeURIComponent(String(boxToiletId)))
        .replace(`{${"box.id"}}`, encodeURIComponent(String(boxId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BoxesApi - functional programming interface
 * @export
 */
export const BoxesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 個室登録
     * @param {string} companyId
     * @param {string} boxToiletId この個室が存在するトイレのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBox(
      companyId: string,
      boxToiletId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Box> {
      const localVarAxiosArgs = BoxesApiAxiosParamCreator(
        configuration
      ).createBox(companyId, boxToiletId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 個室削除
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBox(
      companyId: string,
      toiletId: string,
      boxId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = BoxesApiAxiosParamCreator(
        configuration
      ).deleteBox(companyId, toiletId, boxId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 個室取得
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBox(
      companyId: string,
      toiletId: string,
      boxId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Box> {
      const localVarAxiosArgs = BoxesApiAxiosParamCreator(configuration).getBox(
        companyId,
        toiletId,
        boxId,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 個室検索
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listBoxes(
      companyId: string,
      toiletId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListBoxesResponse> {
      const localVarAxiosArgs = BoxesApiAxiosParamCreator(
        configuration
      ).listBoxes(companyId, toiletId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 個室更新
     * @param {string} companyId
     * @param {string} boxToiletId この個室が存在するトイレのID
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBox(
      companyId: string,
      boxToiletId: string,
      boxId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Box> {
      const localVarAxiosArgs = BoxesApiAxiosParamCreator(
        configuration
      ).updateBox(companyId, boxToiletId, boxId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * BoxesApi - factory interface
 * @export
 */
export const BoxesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary 個室登録
     * @param {string} companyId
     * @param {string} boxToiletId この個室が存在するトイレのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBox(
      companyId: string,
      boxToiletId: string,
      options?: any
    ): AxiosPromise<V1Box> {
      return BoxesApiFp(configuration).createBox(
        companyId,
        boxToiletId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 個室削除
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBox(
      companyId: string,
      toiletId: string,
      boxId: string,
      options?: any
    ): AxiosPromise<object> {
      return BoxesApiFp(configuration).deleteBox(
        companyId,
        toiletId,
        boxId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 個室取得
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBox(
      companyId: string,
      toiletId: string,
      boxId: string,
      options?: any
    ): AxiosPromise<V1Box> {
      return BoxesApiFp(configuration).getBox(
        companyId,
        toiletId,
        boxId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 個室検索
     * @param {string} companyId
     * @param {string} toiletId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listBoxes(
      companyId: string,
      toiletId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListBoxesResponse> {
      return BoxesApiFp(configuration).listBoxes(
        companyId,
        toiletId,
        filter,
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 個室更新
     * @param {string} companyId
     * @param {string} boxToiletId この個室が存在するトイレのID
     * @param {string} boxId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBox(
      companyId: string,
      boxToiletId: string,
      boxId: string,
      options?: any
    ): AxiosPromise<V1Box> {
      return BoxesApiFp(configuration).updateBox(
        companyId,
        boxToiletId,
        boxId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * BoxesApi - object-oriented interface
 * @export
 * @class BoxesApi
 * @extends {BaseAPI}
 */
export class BoxesApi extends BaseAPI {
  /**
   *
   * @summary 個室登録
   * @param {string} companyId
   * @param {string} boxToiletId この個室が存在するトイレのID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoxesApi
   */
  public createBox(companyId: string, boxToiletId: string, options?: any) {
    return BoxesApiFp(this.configuration).createBox(
      companyId,
      boxToiletId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 個室削除
   * @param {string} companyId
   * @param {string} toiletId
   * @param {string} boxId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoxesApi
   */
  public deleteBox(
    companyId: string,
    toiletId: string,
    boxId: string,
    options?: any
  ) {
    return BoxesApiFp(this.configuration).deleteBox(
      companyId,
      toiletId,
      boxId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 個室取得
   * @param {string} companyId
   * @param {string} toiletId
   * @param {string} boxId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoxesApi
   */
  public getBox(
    companyId: string,
    toiletId: string,
    boxId: string,
    options?: any
  ) {
    return BoxesApiFp(this.configuration).getBox(
      companyId,
      toiletId,
      boxId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 個室検索
   * @param {string} companyId
   * @param {string} toiletId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoxesApi
   */
  public listBoxes(
    companyId: string,
    toiletId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return BoxesApiFp(this.configuration).listBoxes(
      companyId,
      toiletId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 個室更新
   * @param {string} companyId
   * @param {string} boxToiletId この個室が存在するトイレのID
   * @param {string} boxId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoxesApi
   */
  public updateBox(
    companyId: string,
    boxToiletId: string,
    boxId: string,
    options?: any
  ) {
    return BoxesApiFp(this.configuration).updateBox(
      companyId,
      boxToiletId,
      boxId,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * CompaniesApi - axios parameter creator
 * @export
 */
export const CompaniesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 会社停止
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminArchiveCompany(companyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminArchiveCompany."
        );
      }
      const localVarPath = `/v1/admin/companies/{companyId}/archives`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 会社登録
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminCreateCompany(options: any = {}): RequestArgs {
      const localVarPath = `/v1/admin/companies`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 会社取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetCompany(companyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminGetCompany."
        );
      }
      const localVarPath = `/v1/admin/companies/{companyId}`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 会社検索
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListCompanies(
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/v1/admin/companies`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 会社更新
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminUpdateCompany(companyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminUpdateCompany."
        );
      }
      const localVarPath = `/v1/admin/companies/{company.id}`.replace(
        `{${"company.id"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 会社取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(companyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getCompany."
        );
      }
      const localVarPath = `/v1/companies/{companyId}`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 会社停止
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminArchiveCompany(
      companyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = CompaniesApiAxiosParamCreator(
        configuration
      ).adminArchiveCompany(companyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 会社登録
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminCreateCompany(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Company> {
      const localVarAxiosArgs = CompaniesApiAxiosParamCreator(
        configuration
      ).adminCreateCompany(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 会社取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetCompany(
      companyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Company> {
      const localVarAxiosArgs = CompaniesApiAxiosParamCreator(
        configuration
      ).adminGetCompany(companyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 会社検索
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListCompanies(
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListCompaniesResponse> {
      const localVarAxiosArgs = CompaniesApiAxiosParamCreator(
        configuration
      ).adminListCompanies(filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 会社更新
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminUpdateCompany(
      companyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Company> {
      const localVarAxiosArgs = CompaniesApiAxiosParamCreator(
        configuration
      ).adminUpdateCompany(companyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 会社取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(
      companyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Company> {
      const localVarAxiosArgs = CompaniesApiAxiosParamCreator(
        configuration
      ).getCompany(companyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary 会社停止
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminArchiveCompany(
      companyId: string,
      options?: any
    ): AxiosPromise<object> {
      return CompaniesApiFp(configuration).adminArchiveCompany(
        companyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 会社登録
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminCreateCompany(options?: any): AxiosPromise<V1Company> {
      return CompaniesApiFp(configuration).adminCreateCompany(options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @summary 会社取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetCompany(companyId: string, options?: any): AxiosPromise<V1Company> {
      return CompaniesApiFp(configuration).adminGetCompany(companyId, options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @summary 会社検索
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListCompanies(
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListCompaniesResponse> {
      return CompaniesApiFp(configuration).adminListCompanies(
        filter,
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 会社更新
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminUpdateCompany(
      companyId: string,
      options?: any
    ): AxiosPromise<V1Company> {
      return CompaniesApiFp(configuration).adminUpdateCompany(
        companyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 会社取得
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(companyId: string, options?: any): AxiosPromise<V1Company> {
      return CompaniesApiFp(configuration).getCompany(companyId, options)(
        axios,
        basePath
      );
    },
  };
};

/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
  /**
   *
   * @summary 会社停止
   * @param {string} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public adminArchiveCompany(companyId: string, options?: any) {
    return CompaniesApiFp(this.configuration).adminArchiveCompany(
      companyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 会社登録
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public adminCreateCompany(options?: any) {
    return CompaniesApiFp(this.configuration).adminCreateCompany(options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @summary 会社取得
   * @param {string} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public adminGetCompany(companyId: string, options?: any) {
    return CompaniesApiFp(this.configuration).adminGetCompany(
      companyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 会社検索
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public adminListCompanies(filter?: string, page?: number, options?: any) {
    return CompaniesApiFp(this.configuration).adminListCompanies(
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 会社更新
   * @param {string} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public adminUpdateCompany(companyId: string, options?: any) {
    return CompaniesApiFp(this.configuration).adminUpdateCompany(
      companyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 会社取得
   * @param {string} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public getCompany(companyId: string, options?: any) {
    return CompaniesApiFp(this.configuration).getCompany(companyId, options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * GatewaysApi - axios parameter creator
 * @export
 */
export const GatewaysApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary ゲートウェイの紐付け解除
     * @param {string} companyId
     * @param {string} gatewayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteGateway(
      companyId: string,
      gatewayId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminDeleteGateway."
        );
      }
      // verify required parameter 'gatewayId' is not null or undefined
      if (gatewayId === null || gatewayId === undefined) {
        throw new RequiredError(
          "gatewayId",
          "Required parameter gatewayId was null or undefined when calling adminDeleteGateway."
        );
      }
      const localVarPath = `/v1/admin/companies/{companyId}/gateways/{gatewayId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary ゲートウェイの取得
     * @param {string} companyId
     * @param {string} gatewayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetGateway(
      companyId: string,
      gatewayId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminGetGateway."
        );
      }
      // verify required parameter 'gatewayId' is not null or undefined
      if (gatewayId === null || gatewayId === undefined) {
        throw new RequiredError(
          "gatewayId",
          "Required parameter gatewayId was null or undefined when calling adminGetGateway."
        );
      }
      const localVarPath = `/v1/admin/companies/{companyId}/gateways/{gatewayId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary ゲートウェイ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {boolean} [isInstalled]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGateways(
      companyId: string,
      filter?: string,
      page?: number,
      isInstalled?: boolean,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listGateways."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/gateways`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (isInstalled !== undefined) {
        localVarQueryParameter["installed"] = isInstalled;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GatewaysApi - functional programming interface
 * @export
 */
export const GatewaysApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary ゲートウェイの紐付け解除
     * @param {string} companyId
     * @param {string} gatewayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteGateway(
      companyId: string,
      gatewayId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = GatewaysApiAxiosParamCreator(
        configuration
      ).adminDeleteGateway(companyId, gatewayId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary ゲートウェイの取得
     * @param {string} companyId
     * @param {string} gatewayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetGateway(
      companyId: string,
      gatewayId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Gateway> {
      const localVarAxiosArgs = GatewaysApiAxiosParamCreator(
        configuration
      ).adminGetGateway(companyId, gatewayId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary ゲートウェイ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGateways(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListGatewaysResponse> {
      const localVarAxiosArgs = GatewaysApiAxiosParamCreator(
        configuration
      ).listGateways(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * GatewaysApi - factory interface
 * @export
 */
export const GatewaysApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary ゲートウェイの紐付け解除
     * @param {string} companyId
     * @param {string} gatewayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteGateway(
      companyId: string,
      gatewayId: string,
      options?: any
    ): AxiosPromise<object> {
      return GatewaysApiFp(configuration).adminDeleteGateway(
        companyId,
        gatewayId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary ゲートウェイの取得
     * @param {string} companyId
     * @param {string} gatewayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetGateway(
      companyId: string,
      gatewayId: string,
      options?: any
    ): AxiosPromise<V1Gateway> {
      return GatewaysApiFp(configuration).adminGetGateway(
        companyId,
        gatewayId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary ゲートウェイ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGateways(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListGatewaysResponse> {
      return GatewaysApiFp(configuration).listGateways(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
  };
};

/**
 * GatewaysApi - object-oriented interface
 * @export
 * @class GatewaysApi
 * @extends {BaseAPI}
 */
export class GatewaysApi extends BaseAPI {
  /**
   *
   * @summary ゲートウェイの紐付け解除
   * @param {string} companyId
   * @param {string} gatewayId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GatewaysApi
   */
  public adminDeleteGateway(
    companyId: string,
    gatewayId: string,
    options?: any
  ) {
    return GatewaysApiFp(this.configuration).adminDeleteGateway(
      companyId,
      gatewayId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary ゲートウェイの取得
   * @param {string} companyId
   * @param {string} gatewayId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GatewaysApi
   */
  public adminGetGateway(companyId: string, gatewayId: string, options?: any) {
    return GatewaysApiFp(this.configuration).adminGetGateway(
      companyId,
      gatewayId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary ゲートウェイ検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GatewaysApi
   */
  public listGateways(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return GatewaysApiFp(this.configuration).listGateways(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * PasswordApi - axios parameter creator
 * @export
 */
export const PasswordApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary パスワードリセット要求を行う
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(options: any = {}): RequestArgs {
      const localVarPath = `/v1/password/forgot`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary パスワードリセットを行う
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(options: any = {}): RequestArgs {
      const localVarPath = `/v1/password/reset`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PasswordApi - functional programming interface
 * @export
 */
export const PasswordApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary パスワードリセット要求を行う
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = PasswordApiAxiosParamCreator(
        configuration
      ).forgotPassword(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary パスワードリセットを行う
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = PasswordApiAxiosParamCreator(
        configuration
      ).resetPassword(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * PasswordApi - factory interface
 * @export
 */
export const PasswordApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary パスワードリセット要求を行う
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(options?: any): AxiosPromise<object> {
      return PasswordApiFp(configuration).forgotPassword(options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @summary パスワードリセットを行う
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(options?: any): AxiosPromise<object> {
      return PasswordApiFp(configuration).resetPassword(options)(
        axios,
        basePath
      );
    },
  };
};

/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */
export class PasswordApi extends BaseAPI {
  /**
   *
   * @summary パスワードリセット要求を行う
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordApi
   */
  public forgotPassword(options?: any) {
    return PasswordApiFp(this.configuration).forgotPassword(options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @summary パスワードリセットを行う
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordApi
   */
  public resetPassword(options?: any) {
    return PasswordApiFp(this.configuration).resetPassword(options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * PublicPlacesApi - axios parameter creator
 * @export
 */
export const PublicPlacesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 公開場所取得
     * @param {string} companyId
     * @param {string} websiteId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPlace(
      companyId: string,
      websiteId: string,
      toiletId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getPublicPlace."
        );
      }
      // verify required parameter 'websiteId' is not null or undefined
      if (websiteId === null || websiteId === undefined) {
        throw new RequiredError(
          "websiteId",
          "Required parameter websiteId was null or undefined when calling getPublicPlace."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling getPublicPlace."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/websites/{websiteId}/toilets/{toiletId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"websiteId"}}`, encodeURIComponent(String(websiteId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 公開場所検索
     * @param {string} companyId
     * @param {string} websiteId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPublicPlaces(
      companyId: string,
      websiteId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listPublicPlaces."
        );
      }
      // verify required parameter 'websiteId' is not null or undefined
      if (websiteId === null || websiteId === undefined) {
        throw new RequiredError(
          "websiteId",
          "Required parameter websiteId was null or undefined when calling listPublicPlaces."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/websites/{websiteId}/toilets`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"websiteId"}}`, encodeURIComponent(String(websiteId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 公開場所更新
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePublicPlaces(
      companyId: string,
      websiteId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling updatePublicPlaces."
        );
      }
      // verify required parameter 'websiteId' is not null or undefined
      if (websiteId === null || websiteId === undefined) {
        throw new RequiredError(
          "websiteId",
          "Required parameter websiteId was null or undefined when calling updatePublicPlaces."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/websites/{websiteId}/toilets`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"websiteId"}}`, encodeURIComponent(String(websiteId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PublicPlacesApi - functional programming interface
 * @export
 */
export const PublicPlacesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 公開場所取得
     * @param {string} companyId
     * @param {string} websiteId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPlace(
      companyId: string,
      websiteId: string,
      toiletId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1PublicPlace> {
      const localVarAxiosArgs = PublicPlacesApiAxiosParamCreator(
        configuration
      ).getPublicPlace(companyId, websiteId, toiletId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 公開場所検索
     * @param {string} companyId
     * @param {string} websiteId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPublicPlaces(
      companyId: string,
      websiteId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListPublicPlacesResponse> {
      const localVarAxiosArgs = PublicPlacesApiAxiosParamCreator(
        configuration
      ).listPublicPlaces(companyId, websiteId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 公開場所更新
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePublicPlaces(
      companyId: string,
      websiteId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1PublicPlace> {
      const localVarAxiosArgs = PublicPlacesApiAxiosParamCreator(
        configuration
      ).updatePublicPlaces(companyId, websiteId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * PublicPlacesApi - factory interface
 * @export
 */
export const PublicPlacesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary 公開場所取得
     * @param {string} companyId
     * @param {string} websiteId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPlace(
      companyId: string,
      websiteId: string,
      toiletId: string,
      options?: any
    ): AxiosPromise<V1PublicPlace> {
      return PublicPlacesApiFp(configuration).getPublicPlace(
        companyId,
        websiteId,
        toiletId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 公開場所検索
     * @param {string} companyId
     * @param {string} websiteId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPublicPlaces(
      companyId: string,
      websiteId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListPublicPlacesResponse> {
      return PublicPlacesApiFp(configuration).listPublicPlaces(
        companyId,
        websiteId,
        filter,
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 公開場所更新
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePublicPlaces(
      companyId: string,
      websiteId: string,
      options?: any
    ): AxiosPromise<V1PublicPlace> {
      return PublicPlacesApiFp(configuration).updatePublicPlaces(
        companyId,
        websiteId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * PublicPlacesApi - object-oriented interface
 * @export
 * @class PublicPlacesApi
 * @extends {BaseAPI}
 */
export class PublicPlacesApi extends BaseAPI {
  /**
   *
   * @summary 公開場所取得
   * @param {string} companyId
   * @param {string} websiteId
   * @param {string} toiletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPlacesApi
   */
  public getPublicPlace(
    companyId: string,
    websiteId: string,
    toiletId: string,
    options?: any
  ) {
    return PublicPlacesApiFp(this.configuration).getPublicPlace(
      companyId,
      websiteId,
      toiletId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 公開場所検索
   * @param {string} companyId
   * @param {string} websiteId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPlacesApi
   */
  public listPublicPlaces(
    companyId: string,
    websiteId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return PublicPlacesApiFp(this.configuration).listPublicPlaces(
      companyId,
      websiteId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 公開場所更新
   * @param {string} companyId
   * @param {string} websiteId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPlacesApi
   */
  public updatePublicPlaces(
    companyId: string,
    websiteId: string,
    options?: any
  ) {
    return PublicPlacesApiFp(this.configuration).updatePublicPlaces(
      companyId,
      websiteId,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * SecondhandsApi - axios parameter creator
 * @export
 */
export const SecondhandsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary 中古ゲートウェイ検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandGateways(page?: number, options: any = {}): RequestArgs {
      const localVarPath = `/v1/admin/secondhand/gateways`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 中古センサー検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandSensors(page?: number, options: any = {}): RequestArgs {
      const localVarPath = `/v1/admin/secondhand/sensors`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 中古タブレット検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandTablets(page?: number, options: any = {}): RequestArgs {
      const localVarPath = `/v1/admin/secondhand/tablets`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SecondhandsApi - functional programming interface
 * @export
 */
export const SecondhandsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 中古ゲートウェイ検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandGateways(
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListSecondhandGatewaysResponse> {
      const localVarAxiosArgs = SecondhandsApiAxiosParamCreator(
        configuration
      ).adminListSecondhandGateways(page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 中古センサー検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandSensors(
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListSecondhandSensorsResponse> {
      const localVarAxiosArgs = SecondhandsApiAxiosParamCreator(
        configuration
      ).adminListSecondhandSensors(page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary 中古タブレット検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandTablets(
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListSecondhandTabletsResponse> {
      const localVarAxiosArgs = SecondhandsApiAxiosParamCreator(
        configuration
      ).adminListSecondhandTablets(page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * SecondhandsApi - factory interface
 * @export
 */
export const SecondhandsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary 中古ゲートウェイ検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandGateways(
      page?: number,
      options?: any
    ): AxiosPromise<V1ListSecondhandGatewaysResponse> {
      return SecondhandsApiFp(configuration).adminListSecondhandGateways(
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 中古センサー検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandSensors(
      page?: number,
      options?: any
    ): AxiosPromise<V1ListSecondhandSensorsResponse> {
      return SecondhandsApiFp(configuration).adminListSecondhandSensors(
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary 中古タブレット検索
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminListSecondhandTablets(
      page?: number,
      options?: any
    ): AxiosPromise<V1ListSecondhandTabletsResponse> {
      return SecondhandsApiFp(configuration).adminListSecondhandTablets(
        page,
        options
      )(axios, basePath);
    },
  };
};

/**
 * SecondhandsApi - object-oriented interface
 * @export
 * @class SecondhandsApi
 * @extends {BaseAPI}
 */
export class SecondhandsApi extends BaseAPI {
  /**
   *
   * @summary 中古ゲートウェイ検索
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecondhandsApi
   */
  public adminListSecondhandGateways(page?: number, options?: any) {
    return SecondhandsApiFp(this.configuration).adminListSecondhandGateways(
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 中古センサー検索
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecondhandsApi
   */
  public adminListSecondhandSensors(page?: number, options?: any) {
    return SecondhandsApiFp(this.configuration).adminListSecondhandSensors(
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary 中古タブレット検索
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecondhandsApi
   */
  public adminListSecondhandTablets(page?: number, options?: any) {
    return SecondhandsApiFp(this.configuration).adminListSecondhandTablets(
      page,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * SensorsApi - axios parameter creator
 * @export
 */
export const SensorsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary センサの紐付け解除
     * @param {string} companyId
     * @param {string} sensorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteSensor(
      companyId: string,
      sensorId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminDeleteSensor."
        );
      }
      // verify required parameter 'sensorId' is not null or undefined
      if (sensorId === null || sensorId === undefined) {
        throw new RequiredError(
          "sensorId",
          "Required parameter sensorId was null or undefined when calling adminDeleteSensor."
        );
      }
      const localVarPath = `/v1/admin/companies/{companyId}/sensors/{sensorId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary センサの取得
     * @param {string} companyId
     * @param {string} sensorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetSensor(
      companyId: string,
      sensorId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminGetSensor."
        );
      }
      // verify required parameter 'sensorId' is not null or undefined
      if (sensorId === null || sensorId === undefined) {
        throw new RequiredError(
          "sensorId",
          "Required parameter sensorId was null or undefined when calling adminGetSensor."
        );
      }
      const localVarPath = `/v1/admin/companies/{companyId}/sensors/{sensorId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary センサ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {boolean} [isInstalled]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSensors(
      companyId: string,
      filter?: string,
      page?: number,
      isInstalled?: boolean,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listSensors."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/sensors`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (isInstalled !== undefined) {
        localVarQueryParameter["installed"] = isInstalled;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SensorsApi - functional programming interface
 * @export
 */
export const SensorsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary センサの紐付け解除
     * @param {string} companyId
     * @param {string} sensorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteSensor(
      companyId: string,
      sensorId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = SensorsApiAxiosParamCreator(
        configuration
      ).adminDeleteSensor(companyId, sensorId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary センサの取得
     * @param {string} companyId
     * @param {string} sensorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetSensor(
      companyId: string,
      sensorId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Sensor> {
      const localVarAxiosArgs = SensorsApiAxiosParamCreator(
        configuration
      ).adminGetSensor(companyId, sensorId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary センサ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSensors(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListSensorsResponse> {
      const localVarAxiosArgs = SensorsApiAxiosParamCreator(
        configuration
      ).listSensors(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * SensorsApi - factory interface
 * @export
 */
export const SensorsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary センサの紐付け解除
     * @param {string} companyId
     * @param {string} sensorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteSensor(
      companyId: string,
      sensorId: string,
      options?: any
    ): AxiosPromise<object> {
      return SensorsApiFp(configuration).adminDeleteSensor(
        companyId,
        sensorId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary センサの取得
     * @param {string} companyId
     * @param {string} sensorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetSensor(
      companyId: string,
      sensorId: string,
      options?: any
    ): AxiosPromise<V1Sensor> {
      return SensorsApiFp(configuration).adminGetSensor(
        companyId,
        sensorId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary センサ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSensors(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListSensorsResponse> {
      return SensorsApiFp(configuration).listSensors(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
  };
};

/**
 * SensorsApi - object-oriented interface
 * @export
 * @class SensorsApi
 * @extends {BaseAPI}
 */
export class SensorsApi extends BaseAPI {
  /**
   *
   * @summary センサの紐付け解除
   * @param {string} companyId
   * @param {string} sensorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SensorsApi
   */
  public adminDeleteSensor(companyId: string, sensorId: string, options?: any) {
    return SensorsApiFp(this.configuration).adminDeleteSensor(
      companyId,
      sensorId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary センサの取得
   * @param {string} companyId
   * @param {string} sensorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SensorsApi
   */
  public adminGetSensor(companyId: string, sensorId: string, options?: any) {
    return SensorsApiFp(this.configuration).adminGetSensor(
      companyId,
      sensorId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary センサ検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SensorsApi
   */
  public listSensors(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return SensorsApiFp(this.configuration).listSensors(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary システム管理者・会社管理者のユーザ認証
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticateAdminSession(options: any = {}): RequestArgs {
      const localVarPath = `/v1/login`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary テナントのユーザ認証
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticateTenantSession(options: any = {}): RequestArgs {
      const localVarPath = `/v1/tenant/login`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary ログアウト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(options: any = {}): RequestArgs {
      const localVarPath = `/v1/logout`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary アクセストークンのリフレッシュ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(options: any = {}): RequestArgs {
      const localVarPath = `/v1/session`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary システム管理者・会社管理者のユーザ認証
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticateAdminSession(
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1AuthenticateAdminSessionResponse> {
      const localVarAxiosArgs = SessionsApiAxiosParamCreator(
        configuration
      ).authenticateAdminSession(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary テナントのユーザ認証
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticateTenantSession(
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1AuthenticateTenantSessionResponse> {
      const localVarAxiosArgs = SessionsApiAxiosParamCreator(
        configuration
      ).authenticateTenantSession(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary ログアウト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = SessionsApiAxiosParamCreator(
        configuration
      ).logout(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary アクセストークンのリフレッシュ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1RefreshTokenResponse> {
      const localVarAxiosArgs = SessionsApiAxiosParamCreator(
        configuration
      ).refreshToken(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary システム管理者・会社管理者のユーザ認証
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticateAdminSession(
      options?: any
    ): AxiosPromise<V1AuthenticateAdminSessionResponse> {
      return SessionsApiFp(configuration).authenticateAdminSession(options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @summary テナントのユーザ認証
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticateTenantSession(
      options?: any
    ): AxiosPromise<V1AuthenticateTenantSessionResponse> {
      return SessionsApiFp(configuration).authenticateTenantSession(options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @summary ログアウト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(options?: any): AxiosPromise<object> {
      return SessionsApiFp(configuration).logout(options)(axios, basePath);
    },
    /**
     *
     * @summary アクセストークンのリフレッシュ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(options?: any): AxiosPromise<V1RefreshTokenResponse> {
      return SessionsApiFp(configuration).refreshToken(options)(
        axios,
        basePath
      );
    },
  };
};

/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
  /**
   *
   * @summary システム管理者・会社管理者のユーザ認証
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public authenticateAdminSession(options?: any) {
    return SessionsApiFp(this.configuration).authenticateAdminSession(options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @summary テナントのユーザ認証
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public authenticateTenantSession(options?: any) {
    return SessionsApiFp(this.configuration).authenticateTenantSession(options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @summary ログアウト
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public logout(options?: any) {
    return SessionsApiFp(this.configuration).logout(options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @summary アクセストークンのリフレッシュ
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public refreshToken(options?: any) {
    return SessionsApiFp(this.configuration).refreshToken(options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * TabletsApi - axios parameter creator
 * @export
 */
export const TabletsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary タブレットの紐付け解除
     * @param {string} companyId
     * @param {string} tabletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteTablet(
      companyId: string,
      tabletId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminDeleteTablet."
        );
      }
      // verify required parameter 'tabletId' is not null or undefined
      if (tabletId === null || tabletId === undefined) {
        throw new RequiredError(
          "tabletId",
          "Required parameter tabletId was null or undefined when calling adminDeleteTablet."
        );
      }
      const localVarPath = `/v1/admin/companies/{companyId}/tablets/{tabletId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"tabletId"}}`, encodeURIComponent(String(tabletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary タブレットの取得
     * @param {string} companyId
     * @param {string} tabletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetTablet(
      companyId: string,
      tabletId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling adminGetTablet."
        );
      }
      // verify required parameter 'tabletId' is not null or undefined
      if (tabletId === null || tabletId === undefined) {
        throw new RequiredError(
          "tabletId",
          "Required parameter tabletId was null or undefined when calling adminGetTablet."
        );
      }
      const localVarPath = `/v1/admin/companies/{companyId}/tablets/{tabletId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"tabletId"}}`, encodeURIComponent(String(tabletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary タブレット検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTablets(
      companyId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listTablets."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/tablets`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TabletsApi - functional programming interface
 * @export
 */
export const TabletsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary タブレットの紐付け解除
     * @param {string} companyId
     * @param {string} tabletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteTablet(
      companyId: string,
      tabletId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = TabletsApiAxiosParamCreator(
        configuration
      ).adminDeleteTablet(companyId, tabletId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary タブレットの取得
     * @param {string} companyId
     * @param {string} tabletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetTablet(
      companyId: string,
      tabletId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Tablet> {
      const localVarAxiosArgs = TabletsApiAxiosParamCreator(
        configuration
      ).adminGetTablet(companyId, tabletId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary タブレット検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTablets(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListTabletsResponse> {
      const localVarAxiosArgs = TabletsApiAxiosParamCreator(
        configuration
      ).listTablets(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * TabletsApi - factory interface
 * @export
 */
export const TabletsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary タブレットの紐付け解除
     * @param {string} companyId
     * @param {string} tabletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteTablet(
      companyId: string,
      tabletId: string,
      options?: any
    ): AxiosPromise<object> {
      return TabletsApiFp(configuration).adminDeleteTablet(
        companyId,
        tabletId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary タブレットの取得
     * @param {string} companyId
     * @param {string} tabletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetTablet(
      companyId: string,
      tabletId: string,
      options?: any
    ): AxiosPromise<V1Tablet> {
      return TabletsApiFp(configuration).adminGetTablet(
        companyId,
        tabletId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary タブレット検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTablets(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListTabletsResponse> {
      return TabletsApiFp(configuration).listTablets(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
  };
};

/**
 * TabletsApi - object-oriented interface
 * @export
 * @class TabletsApi
 * @extends {BaseAPI}
 */
export class TabletsApi extends BaseAPI {
  /**
   *
   * @summary タブレットの紐付け解除
   * @param {string} companyId
   * @param {string} tabletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TabletsApi
   */
  public adminDeleteTablet(companyId: string, tabletId: string, options?: any) {
    return TabletsApiFp(this.configuration).adminDeleteTablet(
      companyId,
      tabletId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary タブレットの取得
   * @param {string} companyId
   * @param {string} tabletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TabletsApi
   */
  public adminGetTablet(companyId: string, tabletId: string, options?: any) {
    return TabletsApiFp(this.configuration).adminGetTablet(
      companyId,
      tabletId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary タブレット検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TabletsApi
   */
  public listTablets(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return TabletsApiFp(this.configuration).listTablets(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * TenantUsersApi - axios parameter creator
 * @export
 */
export const TenantUsersApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary テナントユーザ登録
     * @param {string} tenantUserCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTenantUser(
      tenantUserCompanyId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'tenantUserCompanyId' is not null or undefined
      if (tenantUserCompanyId === null || tenantUserCompanyId === undefined) {
        throw new RequiredError(
          "tenantUserCompanyId",
          "Required parameter tenantUserCompanyId was null or undefined when calling createTenantUser."
        );
      }
      const localVarPath = `/v1/companies/{tenantUser.companyId}/tenant_users`.replace(
        `{${"tenantUser.companyId"}}`,
        encodeURIComponent(String(tenantUserCompanyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary テナントユーザ削除
     * @param {string} companyId
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTenantUser(
      companyId: string,
      tenantUserId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling deleteTenantUser."
        );
      }
      // verify required parameter 'tenantUserId' is not null or undefined
      if (tenantUserId === null || tenantUserId === undefined) {
        throw new RequiredError(
          "tenantUserId",
          "Required parameter tenantUserId was null or undefined when calling deleteTenantUser."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/tenant_users/{tenantUserId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(
          `{${"tenantUserId"}}`,
          encodeURIComponent(String(tenantUserId))
        );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary テナントユーザ取得
     * @param {string} companyId
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantUser(
      companyId: string,
      tenantUserId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getTenantUser."
        );
      }
      // verify required parameter 'tenantUserId' is not null or undefined
      if (tenantUserId === null || tenantUserId === undefined) {
        throw new RequiredError(
          "tenantUserId",
          "Required parameter tenantUserId was null or undefined when calling getTenantUser."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/tenant_users/{tenantUserId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(
          `{${"tenantUserId"}}`,
          encodeURIComponent(String(tenantUserId))
        );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary テナントユーザ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTenantUsers(
      companyId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listTenantUsers."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/tenant_users`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary テナントユーザ更新
     * @param {string} tenantUserCompanyId 会社の ID
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTenantUser(
      tenantUserCompanyId: string,
      tenantUserId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'tenantUserCompanyId' is not null or undefined
      if (tenantUserCompanyId === null || tenantUserCompanyId === undefined) {
        throw new RequiredError(
          "tenantUserCompanyId",
          "Required parameter tenantUserCompanyId was null or undefined when calling updateTenantUser."
        );
      }
      // verify required parameter 'tenantUserId' is not null or undefined
      if (tenantUserId === null || tenantUserId === undefined) {
        throw new RequiredError(
          "tenantUserId",
          "Required parameter tenantUserId was null or undefined when calling updateTenantUser."
        );
      }
      const localVarPath = `/v1/companies/{tenantUser.companyId}/tenant_users/{tenantUser.id}`
        .replace(
          `{${"tenantUser.companyId"}}`,
          encodeURIComponent(String(tenantUserCompanyId))
        )
        .replace(
          `{${"tenantUser.id"}}`,
          encodeURIComponent(String(tenantUserId))
        );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TenantUsersApi - functional programming interface
 * @export
 */
export const TenantUsersApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary テナントユーザ登録
     * @param {string} tenantUserCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTenantUser(
      tenantUserCompanyId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1TenantUser> {
      const localVarAxiosArgs = TenantUsersApiAxiosParamCreator(
        configuration
      ).createTenantUser(tenantUserCompanyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary テナントユーザ削除
     * @param {string} companyId
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTenantUser(
      companyId: string,
      tenantUserId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = TenantUsersApiAxiosParamCreator(
        configuration
      ).deleteTenantUser(companyId, tenantUserId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary テナントユーザ取得
     * @param {string} companyId
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantUser(
      companyId: string,
      tenantUserId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1TenantUser> {
      const localVarAxiosArgs = TenantUsersApiAxiosParamCreator(
        configuration
      ).getTenantUser(companyId, tenantUserId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary テナントユーザ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTenantUsers(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListTenantUsersResponse> {
      const localVarAxiosArgs = TenantUsersApiAxiosParamCreator(
        configuration
      ).listTenantUsers(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary テナントユーザ更新
     * @param {string} tenantUserCompanyId 会社の ID
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTenantUser(
      tenantUserCompanyId: string,
      tenantUserId: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1TenantUser> {
      const localVarAxiosArgs = TenantUsersApiAxiosParamCreator(
        configuration
      ).updateTenantUser(tenantUserCompanyId, tenantUserId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * TenantUsersApi - factory interface
 * @export
 */
export const TenantUsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary テナントユーザ登録
     * @param {string} tenantUserCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTenantUser(
      tenantUserCompanyId: string,
      options?: any
    ): AxiosPromise<V1TenantUser> {
      return TenantUsersApiFp(configuration).createTenantUser(
        tenantUserCompanyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary テナントユーザ削除
     * @param {string} companyId
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTenantUser(
      companyId: string,
      tenantUserId: string,
      options?: any
    ): AxiosPromise<object> {
      return TenantUsersApiFp(configuration).deleteTenantUser(
        companyId,
        tenantUserId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary テナントユーザ取得
     * @param {string} companyId
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantUser(
      companyId: string,
      tenantUserId: string,
      options?: any
    ): AxiosPromise<V1TenantUser> {
      return TenantUsersApiFp(configuration).getTenantUser(
        companyId,
        tenantUserId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary テナントユーザ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTenantUsers(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListTenantUsersResponse> {
      return TenantUsersApiFp(configuration).listTenantUsers(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary テナントユーザ更新
     * @param {string} tenantUserCompanyId 会社の ID
     * @param {string} tenantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTenantUser(
      tenantUserCompanyId: string,
      tenantUserId: string,
      options?: any
    ): AxiosPromise<V1TenantUser> {
      return TenantUsersApiFp(configuration).updateTenantUser(
        tenantUserCompanyId,
        tenantUserId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * TenantUsersApi - object-oriented interface
 * @export
 * @class TenantUsersApi
 * @extends {BaseAPI}
 */
export class TenantUsersApi extends BaseAPI {
  /**
   *
   * @summary テナントユーザ登録
   * @param {string} tenantUserCompanyId 会社の ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantUsersApi
   */
  public createTenantUser(tenantUserCompanyId: string, options?: any) {
    return TenantUsersApiFp(this.configuration).createTenantUser(
      tenantUserCompanyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary テナントユーザ削除
   * @param {string} companyId
   * @param {string} tenantUserId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantUsersApi
   */
  public deleteTenantUser(
    companyId: string,
    tenantUserId: string,
    options?: any
  ) {
    return TenantUsersApiFp(this.configuration).deleteTenantUser(
      companyId,
      tenantUserId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary テナントユーザ取得
   * @param {string} companyId
   * @param {string} tenantUserId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantUsersApi
   */
  public getTenantUser(companyId: string, tenantUserId: string, options?: any) {
    return TenantUsersApiFp(this.configuration).getTenantUser(
      companyId,
      tenantUserId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary テナントユーザ検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantUsersApi
   */
  public listTenantUsers(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return TenantUsersApiFp(this.configuration).listTenantUsers(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary テナントユーザ更新
   * @param {string} tenantUserCompanyId 会社の ID
   * @param {string} tenantUserId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantUsersApi
   */
  public updateTenantUser(
    tenantUserCompanyId: string,
    tenantUserId: string,
    options?: any
  ) {
    return TenantUsersApiFp(this.configuration).updateTenantUser(
      tenantUserCompanyId,
      tenantUserId,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [websiteCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthParameters(websiteCode?: string, options: any = {}): RequestArgs {
      const localVarPath = `/v1/tenant/auth_parameters`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (websiteCode !== undefined) {
        localVarQueryParameter["websiteCode"] = websiteCode;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [websiteCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenant(websiteCode?: string, options: any = {}): RequestArgs {
      const localVarPath = `/v1/tenants/toilets`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (websiteCode !== undefined) {
        localVarQueryParameter["websiteCode"] = websiteCode;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [websiteCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthParameters(
      websiteCode?: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1GetAuthParametersResponse> {
      const localVarAxiosArgs = TenantsApiAxiosParamCreator(
        configuration
      ).getAuthParameters(websiteCode, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} [websiteCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenant(
      websiteCode?: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1GetTenantResponse> {
      const localVarAxiosArgs = TenantsApiAxiosParamCreator(
        configuration
      ).getTenant(websiteCode, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} [websiteCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthParameters(
      websiteCode?: string,
      options?: any
    ): AxiosPromise<V1GetAuthParametersResponse> {
      return TenantsApiFp(configuration).getAuthParameters(
        websiteCode,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {string} [websiteCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenant(
      websiteCode?: string,
      options?: any
    ): AxiosPromise<V1GetTenantResponse> {
      return TenantsApiFp(configuration).getTenant(websiteCode, options)(
        axios,
        basePath
      );
    },
  };
};

/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI {
  /**
   *
   * @param {string} [websiteCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantsApi
   */
  public getAuthParameters(websiteCode?: string, options?: any) {
    return TenantsApiFp(this.configuration).getAuthParameters(
      websiteCode,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} [websiteCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantsApi
   */
  public getTenant(websiteCode?: string, options?: any) {
    return TenantsApiFp(this.configuration).getTenant(websiteCode, options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * ToiletsApi - axios parameter creator
 * @export
 */
export const ToiletsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary トイレ登録
     * @param {string} toiletCompanyId このトイレを所有する会社のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createToilet(toiletCompanyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'toiletCompanyId' is not null or undefined
      if (toiletCompanyId === null || toiletCompanyId === undefined) {
        throw new RequiredError(
          "toiletCompanyId",
          "Required parameter toiletCompanyId was null or undefined when calling createToilet."
        );
      }
      const localVarPath = `/v1/companies/{toilet.companyId}/toilets`.replace(
        `{${"toilet.companyId"}}`,
        encodeURIComponent(String(toiletCompanyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary トイレ削除
     * @param {string} companyId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteToilet(
      companyId: string,
      toiletId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling deleteToilet."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling deleteToilet."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toilets/{toiletId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary トイレ取得
     * @param {string} companyId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getToilet(
      companyId: string,
      toiletId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getToilet."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling getToilet."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toilets/{toiletId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"toiletId"}}`, encodeURIComponent(String(toiletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary トイレ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listToilets(
      companyId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listToilets."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/toilets`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary トイレ更新
     * @param {string} toiletCompanyId このトイレを所有する会社のID
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateToilet(
      toiletCompanyId: string,
      toiletId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'toiletCompanyId' is not null or undefined
      if (toiletCompanyId === null || toiletCompanyId === undefined) {
        throw new RequiredError(
          "toiletCompanyId",
          "Required parameter toiletCompanyId was null or undefined when calling updateToilet."
        );
      }
      // verify required parameter 'toiletId' is not null or undefined
      if (toiletId === null || toiletId === undefined) {
        throw new RequiredError(
          "toiletId",
          "Required parameter toiletId was null or undefined when calling updateToilet."
        );
      }
      const localVarPath = `/v1/companies/{toilet.companyId}/toilets/{toilet.id}`
        .replace(
          `{${"toilet.companyId"}}`,
          encodeURIComponent(String(toiletCompanyId))
        )
        .replace(`{${"toilet.id"}}`, encodeURIComponent(String(toiletId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ToiletsApi - functional programming interface
 * @export
 */
export const ToiletsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary トイレ登録
     * @param {string} toiletCompanyId このトイレを所有する会社のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createToilet(
      toiletCompanyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Toilet> {
      const localVarAxiosArgs = ToiletsApiAxiosParamCreator(
        configuration
      ).createToilet(toiletCompanyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary トイレ削除
     * @param {string} companyId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteToilet(
      companyId: string,
      toiletId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = ToiletsApiAxiosParamCreator(
        configuration
      ).deleteToilet(companyId, toiletId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary トイレ取得
     * @param {string} companyId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getToilet(
      companyId: string,
      toiletId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Toilet> {
      const localVarAxiosArgs = ToiletsApiAxiosParamCreator(
        configuration
      ).getToilet(companyId, toiletId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary トイレ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listToilets(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListToiletsResponse> {
      const localVarAxiosArgs = ToiletsApiAxiosParamCreator(
        configuration
      ).listToilets(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary トイレ更新
     * @param {string} toiletCompanyId このトイレを所有する会社のID
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateToilet(
      toiletCompanyId: string,
      toiletId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Toilet> {
      const localVarAxiosArgs = ToiletsApiAxiosParamCreator(
        configuration
      ).updateToilet(toiletCompanyId, toiletId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ToiletsApi - factory interface
 * @export
 */
export const ToiletsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary トイレ登録
     * @param {string} toiletCompanyId このトイレを所有する会社のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createToilet(
      toiletCompanyId: string,
      options?: any
    ): AxiosPromise<V1Toilet> {
      return ToiletsApiFp(configuration).createToilet(toiletCompanyId, options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @summary トイレ削除
     * @param {string} companyId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteToilet(
      companyId: string,
      toiletId: string,
      options?: any
    ): AxiosPromise<object> {
      return ToiletsApiFp(configuration).deleteToilet(
        companyId,
        toiletId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary トイレ取得
     * @param {string} companyId
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getToilet(
      companyId: string,
      toiletId: string,
      options?: any
    ): AxiosPromise<V1Toilet> {
      return ToiletsApiFp(configuration).getToilet(
        companyId,
        toiletId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary トイレ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listToilets(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListToiletsResponse> {
      return ToiletsApiFp(configuration).listToilets(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary トイレ更新
     * @param {string} toiletCompanyId このトイレを所有する会社のID
     * @param {string} toiletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateToilet(
      toiletCompanyId: string,
      toiletId: string,
      options?: any
    ): AxiosPromise<V1Toilet> {
      return ToiletsApiFp(configuration).updateToilet(
        toiletCompanyId,
        toiletId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * ToiletsApi - object-oriented interface
 * @export
 * @class ToiletsApi
 * @extends {BaseAPI}
 */
export class ToiletsApi extends BaseAPI {
  /**
   *
   * @summary トイレ登録
   * @param {string} toiletCompanyId このトイレを所有する会社のID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToiletsApi
   */
  public createToilet(toiletCompanyId: string, options?: any) {
    return ToiletsApiFp(this.configuration).createToilet(
      toiletCompanyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary トイレ削除
   * @param {string} companyId
   * @param {string} toiletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToiletsApi
   */
  public deleteToilet(companyId: string, toiletId: string, options?: any) {
    return ToiletsApiFp(this.configuration).deleteToilet(
      companyId,
      toiletId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary トイレ取得
   * @param {string} companyId
   * @param {string} toiletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToiletsApi
   */
  public getToilet(companyId: string, toiletId: string, options?: any) {
    return ToiletsApiFp(this.configuration).getToilet(
      companyId,
      toiletId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary トイレ検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToiletsApi
   */
  public listToilets(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return ToiletsApiFp(this.configuration).listToilets(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary トイレ更新
   * @param {string} toiletCompanyId このトイレを所有する会社のID
   * @param {string} toiletId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToiletsApi
   */
  public updateToilet(
    toiletCompanyId: string,
    toiletId: string,
    options?: any
  ) {
    return ToiletsApiFp(this.configuration).updateToilet(
      toiletCompanyId,
      toiletId,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary ユーザ登録
     * @param {string} userCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(userCompanyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'userCompanyId' is not null or undefined
      if (userCompanyId === null || userCompanyId === undefined) {
        throw new RequiredError(
          "userCompanyId",
          "Required parameter userCompanyId was null or undefined when calling createUser."
        );
      }
      const localVarPath = `/v1/companies/{user.companyId}/users`.replace(
        `{${"user.companyId"}}`,
        encodeURIComponent(String(userCompanyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary ユーザ削除
     * @param {string} companyId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(
      companyId: string,
      userId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling deleteUser."
        );
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          "userId",
          "Required parameter userId was null or undefined when calling deleteUser."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/users/{userId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary ユーザ取得
     * @param {string} companyId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(companyId: string, userId: string, options: any = {}): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getUser."
        );
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          "userId",
          "Required parameter userId was null or undefined when calling getUser."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/users/{userId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary ユーザ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers(
      companyId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listUsers."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/users`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary ユーザ更新
     * @param {string} userCompanyId 会社の ID
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(
      userCompanyId: string,
      userId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'userCompanyId' is not null or undefined
      if (userCompanyId === null || userCompanyId === undefined) {
        throw new RequiredError(
          "userCompanyId",
          "Required parameter userCompanyId was null or undefined when calling updateUser."
        );
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          "userId",
          "Required parameter userId was null or undefined when calling updateUser."
        );
      }
      const localVarPath = `/v1/companies/{user.companyId}/users/{user.id}`
        .replace(
          `{${"user.companyId"}}`,
          encodeURIComponent(String(userCompanyId))
        )
        .replace(`{${"user.id"}}`, encodeURIComponent(String(userId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary ユーザ登録
     * @param {string} userCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(
      userCompanyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1User> {
      const localVarAxiosArgs = UsersApiAxiosParamCreator(
        configuration
      ).createUser(userCompanyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary ユーザ削除
     * @param {string} companyId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(
      companyId: string,
      userId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = UsersApiAxiosParamCreator(
        configuration
      ).deleteUser(companyId, userId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary ユーザ取得
     * @param {string} companyId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      companyId: string,
      userId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1User> {
      const localVarAxiosArgs = UsersApiAxiosParamCreator(
        configuration
      ).getUser(companyId, userId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary ユーザ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListUsersResponse> {
      const localVarAxiosArgs = UsersApiAxiosParamCreator(
        configuration
      ).listUsers(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary ユーザ更新
     * @param {string} userCompanyId 会社の ID
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(
      userCompanyId: string,
      userId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1User> {
      const localVarAxiosArgs = UsersApiAxiosParamCreator(
        configuration
      ).updateUser(userCompanyId, userId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary ユーザ登録
     * @param {string} userCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(userCompanyId: string, options?: any): AxiosPromise<V1User> {
      return UsersApiFp(configuration).createUser(userCompanyId, options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @summary ユーザ削除
     * @param {string} companyId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(
      companyId: string,
      userId: string,
      options?: any
    ): AxiosPromise<object> {
      return UsersApiFp(configuration).deleteUser(
        companyId,
        userId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary ユーザ取得
     * @param {string} companyId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      companyId: string,
      userId: string,
      options?: any
    ): AxiosPromise<V1User> {
      return UsersApiFp(configuration).getUser(
        companyId,
        userId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary ユーザ検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListUsersResponse> {
      return UsersApiFp(configuration).listUsers(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary ユーザ更新
     * @param {string} userCompanyId 会社の ID
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(
      userCompanyId: string,
      userId: string,
      options?: any
    ): AxiosPromise<V1User> {
      return UsersApiFp(configuration).updateUser(
        userCompanyId,
        userId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   *
   * @summary ユーザ登録
   * @param {string} userCompanyId 会社の ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public createUser(userCompanyId: string, options?: any) {
    return UsersApiFp(this.configuration).createUser(userCompanyId, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @summary ユーザ削除
   * @param {string} companyId
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public deleteUser(companyId: string, userId: string, options?: any) {
    return UsersApiFp(this.configuration).deleteUser(
      companyId,
      userId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary ユーザ取得
   * @param {string} companyId
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public getUser(companyId: string, userId: string, options?: any) {
    return UsersApiFp(this.configuration).getUser(
      companyId,
      userId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary ユーザ検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public listUsers(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return UsersApiFp(this.configuration).listUsers(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary ユーザ更新
   * @param {string} userCompanyId 会社の ID
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public updateUser(userCompanyId: string, userId: string, options?: any) {
    return UsersApiFp(this.configuration).updateUser(
      userCompanyId,
      userId,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * VacancyApi - axios parameter creator
 * @export
 */
export const VacancyApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} websiteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantWebsite(websiteCode: string, options: any = {}): RequestArgs {
      // verify required parameter 'websiteCode' is not null or undefined
      if (websiteCode === null || websiteCode === undefined) {
        throw new RequiredError(
          "websiteCode",
          "Required parameter websiteCode was null or undefined when calling getTenantWebsite."
        );
      }
      const localVarPath = `/v1/tenant/websites/{websiteCode}`.replace(
        `{${"websiteCode"}}`,
        encodeURIComponent(String(websiteCode))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} websiteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantWebsiteStatus(
      websiteCode: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'websiteCode' is not null or undefined
      if (websiteCode === null || websiteCode === undefined) {
        throw new RequiredError(
          "websiteCode",
          "Required parameter websiteCode was null or undefined when calling getTenantWebsiteStatus."
        );
      }
      const localVarPath = `/v1/tenant/websites/{websiteCode}/get_status`.replace(
        `{${"websiteCode"}}`,
        encodeURIComponent(String(websiteCode))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VacancyApi - functional programming interface
 * @export
 */
export const VacancyApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} websiteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantWebsite(
      websiteCode: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1TenantWebsite> {
      const localVarAxiosArgs = VacancyApiAxiosParamCreator(
        configuration
      ).getTenantWebsite(websiteCode, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
          params: options,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} websiteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantWebsiteStatus(
      websiteCode: string,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1GetTenantWebsiteStatusResponse> {
      const localVarAxiosArgs = VacancyApiAxiosParamCreator(
        configuration
      ).getTenantWebsiteStatus(websiteCode, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * VacancyApi - factory interface
 * @export
 */
export const VacancyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} websiteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantWebsite(
      websiteCode: string,
      options?: any
    ): AxiosPromise<V1TenantWebsite> {
      return VacancyApiFp(configuration).getTenantWebsite(websiteCode, options)(
        axios,
        basePath
      );
    },
    /**
     *
     * @param {string} websiteCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTenantWebsiteStatus(
      websiteCode: string,
      options?: any
    ): AxiosPromise<V1GetTenantWebsiteStatusResponse> {
      return VacancyApiFp(configuration).getTenantWebsiteStatus(
        websiteCode,
        options
      )(axios, basePath);
    },
  };
};

/**
 * VacancyApi - object-oriented interface
 * @export
 * @class VacancyApi
 * @extends {BaseAPI}
 */
export class VacancyApi extends BaseAPI {
  /**
   *
   * @param {string} websiteCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VacancyApi
   */
  public getTenantWebsite(websiteCode: string, options?: any) {
    return VacancyApiFp(this.configuration).getTenantWebsite(
      websiteCode,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} websiteCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VacancyApi
   */
  public getTenantWebsiteStatus(websiteCode: string, options?: any) {
    return VacancyApiFp(this.configuration).getTenantWebsiteStatus(
      websiteCode,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * WebsitesApi - axios parameter creator
 * @export
 */
export const WebsitesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Website登録
     * @param {string} websiteCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWebsite(websiteCompanyId: string, options: any = {}): RequestArgs {
      // verify required parameter 'websiteCompanyId' is not null or undefined
      if (websiteCompanyId === null || websiteCompanyId === undefined) {
        throw new RequiredError(
          "websiteCompanyId",
          "Required parameter websiteCompanyId was null or undefined when calling createWebsite."
        );
      }
      const localVarPath = `/v1/companies/{website.companyId}/websites`.replace(
        `{${"website.companyId"}}`,
        encodeURIComponent(String(websiteCompanyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Website削除
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWebsite(
      companyId: string,
      websiteId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling deleteWebsite."
        );
      }
      // verify required parameter 'websiteId' is not null or undefined
      if (websiteId === null || websiteId === undefined) {
        throw new RequiredError(
          "websiteId",
          "Required parameter websiteId was null or undefined when calling deleteWebsite."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/websites/{websiteId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"websiteId"}}`, encodeURIComponent(String(websiteId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Website取得
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWebsite(
      companyId: string,
      websiteId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling getWebsite."
        );
      }
      // verify required parameter 'websiteId' is not null or undefined
      if (websiteId === null || websiteId === undefined) {
        throw new RequiredError(
          "websiteId",
          "Required parameter websiteId was null or undefined when calling getWebsite."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/websites/{websiteId}`
        .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
        .replace(`{${"websiteId"}}`, encodeURIComponent(String(websiteId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Website検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listWebsites(
      companyId: string,
      filter?: string,
      page?: number,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          "companyId",
          "Required parameter companyId was null or undefined when calling listWebsites."
        );
      }
      const localVarPath = `/v1/companies/{companyId}/websites`.replace(
        `{${"companyId"}}`,
        encodeURIComponent(String(companyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Website更新
     * @param {string} websiteCompanyId 会社の ID
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWebsite(
      websiteCompanyId: string,
      websiteId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'websiteCompanyId' is not null or undefined
      if (websiteCompanyId === null || websiteCompanyId === undefined) {
        throw new RequiredError(
          "websiteCompanyId",
          "Required parameter websiteCompanyId was null or undefined when calling updateWebsite."
        );
      }
      // verify required parameter 'websiteId' is not null or undefined
      if (websiteId === null || websiteId === undefined) {
        throw new RequiredError(
          "websiteId",
          "Required parameter websiteId was null or undefined when calling updateWebsite."
        );
      }
      const localVarPath = `/v1/companies/{website.companyId}/websites/{website.id}`
        .replace(
          `{${"website.companyId"}}`,
          encodeURIComponent(String(websiteCompanyId))
        )
        .replace(`{${"website.id"}}`, encodeURIComponent(String(websiteId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WebsitesApi - functional programming interface
 * @export
 */
export const WebsitesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Website登録
     * @param {string} websiteCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWebsite(
      websiteCompanyId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Website> {
      const localVarAxiosArgs = WebsitesApiAxiosParamCreator(
        configuration
      ).createWebsite(websiteCompanyId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Website削除
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWebsite(
      companyId: string,
      websiteId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = WebsitesApiAxiosParamCreator(
        configuration
      ).deleteWebsite(companyId, websiteId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Website取得
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWebsite(
      companyId: string,
      websiteId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Website> {
      const localVarAxiosArgs = WebsitesApiAxiosParamCreator(
        configuration
      ).getWebsite(companyId, websiteId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Website検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listWebsites(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<V1ListWebsitesResponse> {
      const localVarAxiosArgs = WebsitesApiAxiosParamCreator(
        configuration
      ).listWebsites(companyId, filter, page, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Website更新
     * @param {string} websiteCompanyId 会社の ID
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWebsite(
      websiteCompanyId: string,
      websiteId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Website> {
      const localVarAxiosArgs = WebsitesApiAxiosParamCreator(
        configuration
      ).updateWebsite(websiteCompanyId, websiteId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * WebsitesApi - factory interface
 * @export
 */
export const WebsitesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Website登録
     * @param {string} websiteCompanyId 会社の ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWebsite(
      websiteCompanyId: string,
      options?: any
    ): AxiosPromise<V1Website> {
      return WebsitesApiFp(configuration).createWebsite(
        websiteCompanyId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary Website削除
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteWebsite(
      companyId: string,
      websiteId: string,
      options?: any
    ): AxiosPromise<object> {
      return WebsitesApiFp(configuration).deleteWebsite(
        companyId,
        websiteId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary Website取得
     * @param {string} companyId
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWebsite(
      companyId: string,
      websiteId: string,
      options?: any
    ): AxiosPromise<V1Website> {
      return WebsitesApiFp(configuration).getWebsite(
        companyId,
        websiteId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary Website検索
     * @param {string} companyId
     * @param {string} [filter]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listWebsites(
      companyId: string,
      filter?: string,
      page?: number,
      options?: any
    ): AxiosPromise<V1ListWebsitesResponse> {
      return WebsitesApiFp(configuration).listWebsites(
        companyId,
        filter,
        page,
        options
      )(axios, basePath);
    },
    /**
     *
     * @summary Website更新
     * @param {string} websiteCompanyId 会社の ID
     * @param {string} websiteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWebsite(
      websiteCompanyId: string,
      websiteId: string,
      options?: any
    ): AxiosPromise<V1Website> {
      return WebsitesApiFp(configuration).updateWebsite(
        websiteCompanyId,
        websiteId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * WebsitesApi - object-oriented interface
 * @export
 * @class WebsitesApi
 * @extends {BaseAPI}
 */
export class WebsitesApi extends BaseAPI {
  /**
   *
   * @summary Website登録
   * @param {string} websiteCompanyId 会社の ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebsitesApi
   */
  public createWebsite(websiteCompanyId: string, options?: any) {
    return WebsitesApiFp(this.configuration).createWebsite(
      websiteCompanyId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary Website削除
   * @param {string} companyId
   * @param {string} websiteId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebsitesApi
   */
  public deleteWebsite(companyId: string, websiteId: string, options?: any) {
    return WebsitesApiFp(this.configuration).deleteWebsite(
      companyId,
      websiteId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary Website取得
   * @param {string} companyId
   * @param {string} websiteId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebsitesApi
   */
  public getWebsite(companyId: string, websiteId: string, options?: any) {
    return WebsitesApiFp(this.configuration).getWebsite(
      companyId,
      websiteId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary Website検索
   * @param {string} companyId
   * @param {string} [filter]
   * @param {number} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebsitesApi
   */
  public listWebsites(
    companyId: string,
    filter?: string,
    page?: number,
    options?: any
  ) {
    return WebsitesApiFp(this.configuration).listWebsites(
      companyId,
      filter,
      page,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary Website更新
   * @param {string} websiteCompanyId 会社の ID
   * @param {string} websiteId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebsitesApi
   */
  public updateWebsite(
    websiteCompanyId: string,
    websiteId: string,
    options?: any
  ) {
    return WebsitesApiFp(this.configuration).updateWebsite(
      websiteCompanyId,
      websiteId,
      options
    )(this.axios, this.basePath);
  }
}
